﻿import VectorSource from 'ol/source/Vector.js';
import TileWMSSource from 'ol/source/TileWMS.js';
import ImageWMSSource from 'ol/source/ImageWMS.js';
import ImageSource from 'ol/source/Image.js';
import TileLayer from 'ol/layer/Tile.js';
import TileWMS from 'ol/source/TileWMS.js';
import ImageWMS from 'ol/source/imageWMS.js';
import WMTSCapabilities from 'ol/format/WMTSCapabilities.js';
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS.js';
import OSM from 'ol/source/OSM.js';
import ImageLayer from 'ol/layer/Image.js';
import WKT from 'ol/format/WKT.js';
import VectorLayer from 'ol/layer/Vector.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { defaults as defaultControls, ScaleLine } from 'ol/control.js';
import { defaults as defaultInteractions } from 'ol/interaction.js';
import Circle from 'ol/geom/Circle.js';
import Feature from 'ol/Feature.js';
import Overlay from 'ol/Overlay.js';
import { addProjection } from 'ol/proj.js';
import Projection from 'ol/proj/Projection.js';
import { register } from 'ol/proj/proj4.js';
import proj4 from 'proj4';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import { Utility } from '../Utility.js';
import { Settings } from './Settings.js';
import { Pdm } from '../pdm.js';
export { TerritorialManagement };

/**
 * Class TerritorialManagement
 */
const TerritorialManagement = function () {

	// Define this
    var myTerritorialManagement = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Pdm
    this._pdm = new Pdm();

    // Utility
    this._utility = new Utility();

    // Settings of the map
    this._settings = new Settings(null);

    // Option plant selected
    this._hashOption = {
        location_plant: {},
        cartography_extract: {},
        cartography_extract_lp: {},
        cartography_extract_pdmc: {},
        cartography_extract_pdmo: {},
        cartography_extract_pdmr: {},
        cartography_extract_pdmpp: {},
        location_plant_pdmo: {},
        location_plant_pdmc: {},
        location_plant_pdmpp: {}
    };

    // build group location plant definition
    this._hashOptionGroup = {};

    // Info for cartography extract
    this._hashCartographyExtrac = {};

    // Info for location plant group
    this._hashLocationPlantGroup = {};

    // Map hash
    this._hashPlantMap = {};

    // Location plant info
    this._locationPlantInfo = null;

    // Result WMST GetCapabilities
    this._resultWmtsGetCapabilities = null;

    // Feature draw location plant
    this._featureDrawPl = null;

    // Save polygon location plant mode
    this._modeSaveGeom = 'insert';

    // Table layer pdm
    this._datatableLayerPdm = null;

    // Hash for table layer pdm report
    this._hashDatatableLayerPdmReport = {};

    // Pdm analyze info
    this._pdmAnalyzeInfo = null;

    // Pdf object
    this._pdfObj = null;

    // Location plant process number
    this._locationPlantProcessNumber = "";

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------
    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Create location plant
     */
    this.CreateLocationPlant = function () {
        // Start wait
        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', true);

        var idUser = myTerritorialManagement._mapSgs.getSettings().userInfo.userId;

        // Check if any location plant is checked
        if (!$('#id-modal-location-plant-location-active')[0].checked &&
            Object.keys(myTerritorialManagement._hashOption.cartography_extract).length == 0 &&
            !$('#id-modal-location-plant-location-pdmo-active')[0].checked &&
            !$('#id-modal-location-plant-location-pdmc-active')[0].checked &&
            !$('#id-modal-location-plant-location-pdmr-active')[0].checked &&
            !$('#id-modal-location-plant-location-pdmpp-active')[0].checked
           )
        {
            toastr["warning"]("Nenhuma planta seleccionada");
            // Stop wait
            myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);

            return;
        }

        // Get polygon by draw
        var featurePolygon = null;
        if(app.layerDraw.getSource().getFeatures()[0] !== undefined)
        {
            featurePolygon = app.layerDraw.getSource().getFeatures()[0];
            this._modeSaveGeom = 'insert';
        }

        // Get polygon by edition
        if(app.Select.getFeatures().getArray()[0] !== undefined)
        {
            featurePolygon = app.Select.getFeatures().getArray()[0];
            this._modeSaveGeom = 'update';
        }

        // Get polygon by selection
        if(myTerritorialManagement._mapSgs.tooltips._featureInfo.id !== null)
        {
            featurePolygon = myTerritorialManagement._mapSgs.tooltips._featureInfo.feature;
            this._modeSaveGeom = 'select';
        }

        // Get feature
        myTerritorialManagement._featureDrawPl = featurePolygon;
        if (myTerritorialManagement._featureDrawPl === null) {
            toastr["warning"]("Desenhe ou seleccione primeiro no mapa um polígono");

            // Stop wait
            myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);

            return;
        }

        var srid = myTerritorialManagement._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        var geom_wkt = new WKT().writeGeometry(myTerritorialManagement._featureDrawPl.getGeometry());
        var geom_extent = myTerritorialManagement._featureDrawPl.getGeometry().getExtent();

        // -- Create location plant --
        myTerritorialManagement._locationPlantInfo = $('#id-modal-location-plant-form').serializeJSON();
        myTerritorialManagement._locationPlantInfo.geom_wkt = geom_wkt;
        myTerritorialManagement._locationPlantInfo.geom_srid = srid;
        myTerritorialManagement._locationPlantInfo.id_user = idUser;
        myTerritorialManagement._locationPlantInfo.is_public = myTerritorialManagement._mapSgs._settings._mapSettings.map_info.is_public;
        myTerritorialManagement._locationPlantInfo.id_map = myTerritorialManagement._mapSgs._settings._mapSettings.map_info.id;
        myTerritorialManagement._locationPlantInfo.geom_extent = geom_extent.toString();

        // build location plant info
        var buildLocationPlant = { build: $('#id-modal-location-plant-location-active')[0].checked }
        if ($('#id-modal-location-plant-location-active')[0].checked) {
            buildLocationPlant.scale = $('#id-modal-location-plant-pl-scale').val();
            buildLocationPlant.id_location_plant_definition = myTerritorialManagement._hashOption.location_plant.id_location_plant_definition;
            //buildLocationPlant.array_id_layer_metadata = Object.keys(myTerritorialManagement._mapSgs.layerTree.hashLocationPlantLayer).map(function (i) { return parseInt(i, 10) }).sort().toString();
            buildLocationPlant.array_id_layer_metadata = Object.keys(myTerritorialManagement._mapSgs.layerTree.hashLocationPlantLayer).map(function (i) { return i.split(':')[0] }).sort().toString();
            buildLocationPlant.info_json = myTerritorialManagement._hashOption.location_plant.info_json;
        };
        myTerritorialManagement._locationPlantInfo.build_location_plant = buildLocationPlant;

        // Build cartographic extrac info
        var buildCartographicExtract = [];
        if (Object.keys(myTerritorialManagement._hashOption.cartography_extract).length > 0) {
            for (var i = 0; i < Object.keys(myTerritorialManagement._hashOption.cartography_extract).length; i++) {
                var id = Object.keys(myTerritorialManagement._hashOption.cartography_extract)[i];
                var arrayIdBaseLayer = id.split("_");
                var scale = "";
                var idBaseLayer = "";
                if (arrayIdBaseLayer.length > 1) {
                    idBaseLayer = arrayIdBaseLayer[0];
                    scale = arrayIdBaseLayer[1];
                }
                else {
                    idBaseLayer = id;
                    var idScaleSelect = myTerritorialManagement._hashOption.cartography_extract[idBaseLayer].idSelectScale;
                    scale = $('#' + idScaleSelect).val();
                }

                var cartographicExtractObj = {
                    id_base_layer: idBaseLayer,
                    id_location_plant_definition: myTerritorialManagement._hashOption.cartography_extract[id].idLocationPlantDefinition,
                    scale: scale,
                    info_json: myTerritorialManagement._hashOption.cartography_extract[id].info_json
                }
                buildCartographicExtract.push(cartographicExtractObj);
            }
        }
        myTerritorialManagement._locationPlantInfo.build_cartography_extract = buildCartographicExtract;

        // Build PDMO
        var buildPdmo = { build: $('#id-modal-location-plant-location-pdmo-active')[0].checked }
        if ($('#id-modal-location-plant-location-pdmo-active')[0].checked) {
            buildPdmo.scale = $('#id-modal-location-plant-pdmo-pl-scale').val();
            if (Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmo).length > 0) {
                buildPdmo.build_cartography_extract = [];
                for (var t = 0; t < Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmo).length; t++) {
                    var idBaseLayer = Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmo)[t];
                    var cartographicExtractPdmoObj = {
                        id_base_layer: idBaseLayer,
                        id_location_plant_definition: myTerritorialManagement._hashOption.cartography_extract_pdmo[idBaseLayer].id_location_plant_definition,
                        scale: $('#id-modal-location-plant-pdmo-pl-scale').val(),
                        info_json: myTerritorialManagement._hashOption.cartography_extract_pdmo[idBaseLayer].info_json
                    }
                    buildPdmo.build_cartography_extract.push(cartographicExtractPdmoObj);
                }
            }
            else {
                buildPdmo.id_request_type = myTerritorialManagement._pdm._requestTypes["PDM_ORDENAMENTO"].id;
                buildPdmo.id_legal_document = Object.keys(myTerritorialManagement._pdm._legalDocuments)[0];
                buildPdmo.id_location_plant_definition = myTerritorialManagement._hashOption.location_plant_pdmo.id_location_plant_definition;
                buildPdmo.info_json = myTerritorialManagement._hashOption.location_plant_pdmo.info_json;
            }
        }
        myTerritorialManagement._locationPlantInfo.build_pdmo = buildPdmo;

        // Build PDMC
        var buildPdmc = { build: $('#id-modal-location-plant-location-pdmc-active')[0].checked }
        if ($('#id-modal-location-plant-location-pdmc-active')[0].checked) {
            buildPdmc.scale = $('#id-modal-location-plant-pdmo-pl-scale').val();
            if (Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmc).length > 0) {
                buildPdmc.build_cartography_extract = [];
                for (var j = 0; j < Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmc).length; j++) {
                    var idBaseLayer = Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmc)[j];
                    var cartographicExtractPdmcObj = {
                        id_base_layer: idBaseLayer,
                        id_location_plant_definition: myTerritorialManagement._hashOption.cartography_extract_pdmc[idBaseLayer].idLocationPlantDefinition,
                        scale: $('#id-modal-location-plant-pdmc-pl-scale').val(),
                        info_json: myTerritorialManagement._hashOption.cartography_extract_pdmc[idBaseLayer].info_json
                    }
                    buildPdmc.build_cartography_extract.push(cartographicExtractPdmcObj);
                }
            }
            else {
                buildPdmc.id_request_type = myTerritorialManagement._pdm._requestTypes["PDM_CONDICIONANTE"].id;
                buildPdmc.id_legal_document = Object.keys(myTerritorialManagement._pdm._legalDocuments)[0];
                buildPdmc.id_location_plant_definition = myTerritorialManagement._hashOption.location_plant_pdmc.id_location_plant_definition;
                buildPdmc.info_json = myTerritorialManagement._hashOption.location_plant_pdmc.info_json;
            }
        }
        myTerritorialManagement._locationPlantInfo.build_pdmc = buildPdmc;

        // Build PDMR
        if ($('#id-modal-location-plant-location-pdmr-active')[0] !== undefined) {
            var buildPdmr = { build: $('#id-modal-location-plant-location-pdmr-active')[0].checked }
            if ($('#id-modal-location-plant-location-pdmr-active')[0].checked) {
                buildPdmr.scale = $('#id-modal-location-plant-pdmr-pl-scale').val();
                if (Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmr).length > 0) {
                    buildPdmr.build_cartography_extract = [];
                    for (var g = 0; g < Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmr).length; g++) {
                        var idBaseLayer = Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmr)[g];
                        var cartographicExtractPdmrObj = {
                            id_base_layer: idBaseLayer,
                            id_location_plant_definition: myTerritorialManagement._hashOption.cartography_extract_pdmr[idBaseLayer].id_location_plant_definition,
                            scale: $('#id-modal-location-plant-pdmr-pl-scale').val(),
                            info_json: myTerritorialManagement._hashOption.cartography_extract_pdmr[idBaseLayer].info_json
                        }
                        buildPdmr.build_cartography_extract.push(cartographicExtractPdmrObj);
                    }
                }
                else {
                    buildPdmr.id_request_type = myTerritorialManagement._pdm._requestTypes["PDM_RUIDO"].id;
                    buildPdmr.id_legal_document = Object.keys(myTerritorialManagement._pdm._legalDocuments)[0];
                    buildPdmr.id_location_plant_definition = myTerritorialManagement._hashOption.location_plant_pdmr.id_location_plant_definition;
                    buildPdmr.info_json = myTerritorialManagement._hashOption.location_plant_pdmr.info_json;
                }
            }
            myTerritorialManagement._locationPlantInfo.build_pdmr = buildPdmr;
        }
        else {
            myTerritorialManagement._locationPlantInfo.build_pdmr = { build: false };
        }

        // Build PDM plano pormenor
        if ($('#id-modal-location-plant-location-pdmpp-active')[0] !== undefined)
        {
            var buildPdmPp = { build: $('#id-modal-location-plant-location-pdmpp-active')[0].checked }
            if ($('#id-modal-location-plant-location-pdmpp-active')[0].checked)
            {
                buildPdmPp.scale = $('#id-modal-location-plant-pdmpp-pl-scale').val();
                if (Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmpp).length > 0)
                {
                    buildPdmPp.build_cartography_extract = [];
                    for (var g = 0; g < Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmpp).length; g++)
                    {
                        var idBaseLayer = Object.keys(myTerritorialManagement._hashOption.cartography_extract_pdmpp)[g];
                        var cartographicExtractPdmPpObj =
                        {
                            id_base_layer: idBaseLayer,
                            id_location_plant_definition: myTerritorialManagement._hashOption.cartography_extract_pdmpp[idBaseLayer].id_location_plant_definition,
                            scale: $('#id-modal-location-plant-pdmpp-pl-scale').val(),
                            info_json: myTerritorialManagement._hashOption.cartography_extract_pdmpp[idBaseLayer].info_json
                        }
                        buildPdmPp.build_cartography_extract.push(cartographicExtractPdmPpObj);
                    }
                }
                else
                {
                    buildPdmPp.id_request_type = myTerritorialManagement._pdm._requestTypes["PDM_PP"].id;
                    buildPdmPp.id_legal_document = Object.keys(myTerritorialManagement._pdm._legalDocuments)[0];
                    buildPdmPp.id_location_plant_definition = myTerritorialManagement._hashOption.location_plant_pdmpp.id_location_plant_definition;
                    buildPdmPp.info_json = myTerritorialManagement._hashOption.location_plant_pdmpp.info_json;
                }
            }
            myTerritorialManagement._locationPlantInfo.build_pdmpp = buildPdmPp;
        }
        else
        {
            myTerritorialManagement._locationPlantInfo.build_pdmpp = { build: false };
        }

        // Set extent
        myTerritorialManagement._locationPlantInfo.extent = myTerritorialManagement._mapSgs._settings._mapSettings.map_info.extent;

        // Email check
        ////if (
        ////    (myTerritorialManagement._locationPlantInfo.build_pdmo.build && !myTerritorialManagement._locationPlantInfo.build_pdmo.build_cartography_extract)  ||
        ////    (myTerritorialManagement._locationPlantInfo.build_pdmc.build && !myTerritorialManagement._locationPlantInfo.build_pdmc.build_cartography_extract)
        ////   )
        ////{
        ////    // show modal for fill email
        ////    $('#id-modal-location-plant-email').show();
        ////    // Stop wait
        ////    myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
        ////}
        ////else {
        ////    // No email then execute
        ////    myTerritorialManagement.ExecuteLocationPlantReport();
        ////}

        // No email then execute
        myTerritorialManagement.ExecuteLocationPlantReport();
    };

    /**
     * Execute build location plant
     */
    this.ExecuteLocationPlantReport = function () {
        $.ajax({
            type: 'POST',
            url: '/rest/app/TerritorialManagement/BuildLocationPlant',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(myTerritorialManagement._locationPlantInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao submeter o pedido");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Save in layer location plant geometry
                            var locationPlantLayerClientName = _locationPlantLayerClientNamePrivate;
                            if( myTerritorialManagement._mapSgs._settings._mapSettings.map_info.is_public)
                                locationPlantLayerClientName = _locationPlantLayerClientNamePublic;

                            if(locationPlantLayerClientName !== null && locationPlantLayerClientName !== "") {
                                var layerPlInfo = myTerritorialManagement._mapSgs.layerTree.FindLayerInfoByLayerName(locationPlantLayerClientName);
                                if(layerPlInfo !== undefined) {
                                    if(layerPlInfo.list_column && layerPlInfo.list_column.length > 0) {
                                        var featureProperties = {};
                                        for(var i = 0; i < layerPlInfo.list_column.length; i++) {
                                            var columnInfo = layerPlInfo.list_column[i];
                                            switch(columnInfo.column_name) {
                                                case "DATA":
                                                    var dateObj = new Date();
                                                    var day = myTerritorialManagement._utility.PadLeft(dateObj.getUTCDate(),2);
                                                    var month = myTerritorialManagement._utility.PadLeft(dateObj.getMonth()+1,2);
                                                    var year = dateObj.getFullYear();
                                                    var separator = "-";
                                                    featureProperties[columnInfo.column_name] = day + separator + month + separator + year;
                                                    break;
                                                case "IDPLANTA":
                                                    featureProperties[columnInfo.column_name] = data.result.process_number_location_plant;
                                                    break;
                                                case "UTILIZADOR":
                                                    featureProperties[columnInfo.column_name] = myTerritorialManagement._mapSgs._settings.userInfo.userName;
                                                    break;
                                                //case "Shape":
                                                //    featureProperties[columnInfo.column_name] = myTerritorialManagement._featureDrawPl.getGeometry();
                                                //    break;
                                                default:
                                                    // do nothing
                                            }
                                        }

                                        if( myTerritorialManagement._modeSaveGeom !== 'select')
                                        {
                                            featureProperties[layerPlInfo.layer_info.geomColumnName] = myTerritorialManagement._featureDrawPl.getGeometry();
                                            myTerritorialManagement._featureDrawPl.setProperties(featureProperties);

                                            myTerritorialManagement._mapSgs._TransactWFS2(myTerritorialManagement._modeSaveGeom, myTerritorialManagement._featureDrawPl, layerPlInfo.layer_info);
                                        }
                                    }
                                }
                            }
                            
                            // Url for print preview
                            var url = '/LocationPlant?ID=' + data.result.id_location_plant;
                            window.open(url, '_blank');

                            // Clear draw polygon
                            if (app.layerDraw.getSource()) app.layerDraw.getSource().clear();

                            // Close menubar bottom
                            if ($('#menubar-bottom').is(':visible'))
                                $('#menubar-bottom').toggle('ol-hidden');

                            toastr["success"]("Pedido efectuado com sucesso");
                            break;
                        case "SUCCESS_SEND_BY_EMAIL":
                            toastr["success"]("Pedido efectuado com sucesso. Irá receber em breve um email com o link para as plantas de localização");
                            break;
                        default:
                            toastr["error"]("Erro ao submeter o pedido");
                    }
                }

                // Stop wait
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao submeter o pedido");

                // Stop wait
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    /**
     * Execute Pdm Analyze
     */
    this.ExecutePdmAnalyze = function () {
        var idUser = myTerritorialManagement._mapSgs.getSettings().userInfo.userId;

        // Get feature draw
        myTerritorialManagement._featureDrawPl = app.layerDraw.getSource().getFeatures()[0];
        if (myTerritorialManagement._featureDrawPl === undefined) {
            toastr["warning"]("Desenhe primeiro no mapa um polígono");

            return;
        }

        // Start wait
        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', true);

        // Get Draw
        var srid = myTerritorialManagement._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        var geom_wkt = new WKT().writeGeometry(myTerritorialManagement._featureDrawPl.getGeometry());
        var geom_extent = myTerritorialManagement._featureDrawPl.getGeometry().getExtent();

        // Pdm analyze info
        myTerritorialManagement._pdmAnalyzeInfo = {
            geom_wkt: geom_wkt,
            geom_extent: geom_extent.toString(),
            geom_srid: srid,
            id_user: idUser,
            id_map: myTerritorialManagement._mapSgs._settings._mapSettings.map_info.id,
            id_pdm_request_type: -1, // Do all
            layer_name: "",
            id_feature: ""
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/TerritorialManagement/ExecutePdmAnalyze',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(myTerritorialManagement._pdmAnalyzeInfo),
            async: true,
            timeout: 240000, // sets timeout to 2 minute
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao submeter o pedido");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Show modal
                            $('#id-modal-pdm-analyze-result').show();

                            // -- Clean --
                            myTerritorialManagement._datatableLayerPdm.clear().draw();
                            $('#id-modal-pdm-analyze-result-just-list-zone').hide();
                            $('#id-modal-pdm-analyze-result-just-list ul').empty();

                            // -- Build information layer --
                            var countElement = data.result.list_answer_layer_info.length;
                            var hashForOrder = {};
                            var arrayTableArticle = [];

                            // Group by layer source
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.list_answer_layer_info[i];
                                var key = objEvent.id_rel_layer_source;
                                if(hashForOrder[key] >= 0) {
                                    var pos = hashForOrder[key];
                                    var objArray = arrayTableArticle[pos];
                                    objArray.article_list += "<p><b>" + objEvent.article_list.split('(')[0].replace("Artigo", "Art.") + "</b>(" + objEvent.article_list.split('(')[1] + "</p>";
                                    arrayTableArticle[pos] = objArray;
                                }
                                else {
                                    arrayTableArticle.push({
                                        id_pdm_layer: objEvent.id_pdm_layer,
                                        layer_name: objEvent.layer_name,
                                        intersection_area: (Math.round(objEvent.intersection_area*100)/100), //.toString() + " m" + "<sup>2</sup>",
                                        article_list: "<p><b>" + objEvent.article_list.split('(')[0].replace("Artigo", "Art.") + "</b>(" + objEvent.article_list.split('(')[1] + "</p>",
                                        code_ref_pdm_request_type: objEvent.code_ref_pdm_request_type
                                    });
                                    hashForOrder[key] = arrayTableArticle.length - 1;
                                }
                            }

                            // Group by name
                            var arrayTableByName = [];
                            var hashByName = {};
                            for(var v = 0; v < arrayTableArticle.length; v++) {
                                var objEvent = arrayTableArticle[v];
                                var key = objEvent.layer_name;
                                if(hashByName[key] >= 0) {
                                    var pos = hashByName[key];
                                    var objArray = arrayTableByName[pos];
                                    objArray.intersection_area += objEvent.intersection_area;
                                    objArray.article_list += objEvent.article_list;
                                    arrayTableByName[pos] = objArray;
                                }
                                else {
                                    arrayTableByName.push({
                                        id_pdm_layer: objEvent.id_pdm_layer,
                                        layer_name: objEvent.layer_name,
                                        intersection_area: objEvent.intersection_area, 
                                        article_list: objEvent.article_list,
                                        code_ref_pdm_request_type: objEvent.code_ref_pdm_request_type
                                    });
                                    hashByName[key] = arrayTableByName.length - 1;
                                }
                            }

                            for (let y = 0; y < arrayTableByName.length; y++) {
                                var objEvent = arrayTableByName[y];
                                myTerritorialManagement._datatableLayerPdm.row.add({
                                    id_pdm_layer: objEvent.id_pdm_layer,
                                    layer_name: objEvent.layer_name,
                                    intersection_area: objEvent.intersection_area.toString() + " m" + "<sup>2</sup>",
                                    article_list: objEvent.article_list
                                }).draw();

                                // Just Condicionantes
                                if(objEvent.code_ref_pdm_request_type === 'PDM_CONDICIONANTE') {
                                    $('#id-modal-pdm-analyze-result-just-list-zone').show();
                                    $('#id-modal-pdm-analyze-result-just-list ul').append($('<li>' + objEvent.layer_name + '</li>'))
                                }
                            }
                            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                            // Add layer with no article
                            var countLayerNoArticle = data.result.list_answer_layer_no_article_info.length;
                            for( var q = 0; q < countLayerNoArticle; q++) {
                                var objLayerNoArticle = data.result.list_answer_layer_no_article_info[q];
                                if(objLayerNoArticle.code_ref_pdm_request_type === 'PDM_CONDICIONANTE') {
                                    $('#id-modal-pdm-analyze-result-just-list-zone').show();
                                    $('#id-modal-pdm-analyze-result-just-list ul').append($('<li>' + objLayerNoArticle.layer_name + '</li>'))
                                }
                            }

                            // -- Build article information --
                            var outputPdmArticleScruture = "";
                            var outputPdmArticleScrutureObj = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(myTerritorialManagement._mapSgs._settings.configurationInfo.propertyInfo, "GESTAO_URBANISTICA", "PDM", "OUTPUT_PDM_ARTICLE");
                            if(outputPdmArticleScrutureObj !== undefined)
                                outputPdmArticleScruture = outputPdmArticleScrutureObj.value;

                            var articlesUl = $('<ul class="list pdm-legend-list"></ul>');
                            switch(outputPdmArticleScruture)
                            {
                                case "ARTICLE_ONLY":
                                    var li = $('<li class="article-only"></li>');
                                    // Build article info
                                    myTerritorialManagement._BuildArticleInfo(li, data.result.list_answer_article_info);
                                    articlesUl.append(li);
                                    $('#id-modal-pdm-analyze-result-list-article').append(articlesUl);
                                    break;
                                default:
                                    var lastIdPdmLayer = "";
                                    for (let r = 0; r < data.result.list_answer_layer_info.length; r++)
                                    {
                                        var objEvent = data.result.list_answer_layer_info[r];

                                        // Check if last id pdm layer is the same then next row
                                        if(lastIdPdmLayer === objEvent.id_pdm_layer)
                                        {
                                            continue;
                                        }
                                        lastIdPdmLayer = objEvent.id_pdm_layer;

                                        var li = $('<li title="' + objEvent.layer_name + '"></li>');
                                        // Article
                                        var arrayArticle = data.result.list_answer_layer_article_info.filter(c=> c.id_rel_pdm_layer === objEvent.id_pdm_layer);
                                        var hashTitle = {};
                                        var hashChaper = {};
                                        var hashSection = {};
                                        var hashSubSection = {};
                                        for(var p = 0; p < arrayArticle.length; p++) {
                                            var articleObj = arrayArticle[p];
                                            if(p == 0) {
                                                if(articleObj.name_title !== null && articleObj.name_title !== "") hashTitle[articleObj.name_title] = 1;
                                                if(articleObj.name_chapter !== null && articleObj.name_chapter !== "") hashChaper[articleObj.name_chapter] = 1;
                                                if(articleObj.name_section !== null && articleObj.name_section !== "") hashSection[articleObj.name_section] = 1;
                                                if(articleObj.name_subsection !== null && articleObj.name_subsection !== "") hashSubSection[articleObj.name_subsection] = 1;
                                                //div.append($('<hr/>'));
                                                li.append($('<div class="article-div">' + (p > 0 ? '<br/>' : '') +
                                                            ((articleObj.name_title !== null && articleObj.name_title !== "")?'<h3 class="center-element bolder-element">' + articleObj.name_title + '<h3>': '') +
                                                            ((articleObj.description_title !== null && articleObj.description_title !== "")?'<h3 class="center-element bolder-element">' + articleObj.description_title + '<h3>': '') +
                                                            ((articleObj.name_chapter !== null && articleObj.name_chapter !== "")?'<h4 class="center-element bolder-element">' + articleObj.name_chapter + '<h4>': '') +
                                                            ((articleObj.description_chapter !== null && articleObj.description_chapter !== "")?'<h5 class="center-element bolder-element">' + articleObj.description_chapter + '<h5>': '') +
                                                            ((articleObj.name_section !== null && articleObj.name_section !== "")?'<h4 class="center-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                                                            ((articleObj.description_section !== null && articleObj.description_section !== "")?'<h5 class="center-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                                                            ((articleObj.name_subsection !== null && articleObj.name_subsection !== "")?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                                            ((articleObj.description_subsection !== null && articleObj.description_subsection !== "")?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                                            ((articleObj.name_article !== null && articleObj.name_article !== "")?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                                            ((articleObj.description_article !== null && articleObj.description_article !== "")?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                                            articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                            }
                                            else {
                                                if(!hashTitle[articleObj.name_title]) {
                                                    if(articleObj.name_title !== null && articleObj.name_title !== "") hashTitle[articleObj.name_title] = 1;
                                                    li.append($('<div class="article-div"><br/>' +
                                                                ((articleObj.name_title)?'<h3 class="center-element bolder-element">' + articleObj.name_title + '<h3>': '') +
                                                                ((articleObj.description_title)?'<h3 class="center-element bolder-element">' + articleObj.description_title + '<h3>': '') +
                                                                ((articleObj.name_chapter)?'<h4 class="center-element bolder-element">' + articleObj.name_chapter + '<h4>': '') +
                                                                ((articleObj.description_chapter)?'<h5 class="center-element bolder-element">' + articleObj.description_chapter + '<h5>': '') +
                                                                ((articleObj.name_section)?'<h4 class="center-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                                                                ((articleObj.description_section)?'<h5 class="center-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                                                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                                }
                                                else if(!hashChaper[articleObj.name_chapter]) {
                                                    if(articleObj.name_chapter !== null && articleObj.name_chapter !== "") hashChaper[articleObj.name_chapter] = 1;
                                                    li.append($('<div class="article-div"><br/>' +
                                                                ((articleObj.name_chapter)?'<h4 class="center-element bolder-element">' + articleObj.name_chapter + '<h4>': '') +
                                                                ((articleObj.description_chapter)?'<h5 class="center-element bolder-element">' + articleObj.description_chapter + '<h5>': '') +
                                                                ((articleObj.name_section)?'<h4 class="center-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                                                                ((articleObj.description_section)?'<h5 class="center-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                                                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                        
                                                }
                                                else if(!hashSection[articleObj.name_section]) {
                                                    if(articleObj.name_section !== null && articleObj.name_section !== "") hashSection[articleObj.name_section] = 1;
                                                    li.append($('<div class="article-div"><br/>' +
                                                                ((articleObj.name_section)?'<h4 class="center-element bold-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                                                                ((articleObj.description_section)?'<h5 class="center-element bold-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                                                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                        
                                                }
                                                else if(!hashSubSection[articleObj.name_subsection]) {
                                                    if(articleObj.name_subsection !== null && articleObj.name_subsection !== "") hashSubSection[articleObj.name_subsection] = 1;
                                                    li.append($('<div class="article-div"><br/>' +
                                                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                        
                                                }
                                                else {
                                                    li.append($('<div class="article-div"><br/>' +
                                                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));                                        
                                                }
                                            }
                                        }
                                        articlesUl.append(li);
                                    }
                                    $('#id-modal-pdm-analyze-result-list-article').append(articlesUl);
                            }

                            break;
                        default:
                            toastr["error"]("Erro  o pedido");
                    }
                }

                // Stop wait
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao submeter o pedido");

                // Stop wait
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    };

    /**
     * Execute Pdm Analyze entity
     */
    this.ExecutePdmAnalyzeEntity = function (feature) {
        var idUser = myTerritorialManagement._mapSgs.getSettings().userInfo.userId;

        // Start wait
        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', true);

        // Clean
        $('#id-modal-pdm-analyze-entity-result-entity ul').empty();
        $('#id-modal-pdm-analyze-entity-result-layer ul').empty();

        // Get Draw
        var srid = myTerritorialManagement._mapSgs._settings.projection.getCode().replace('EPSG:', '');
        var geom_wkt = new WKT().writeGeometry(feature.getGeometry());
        var geom_extent = feature.getGeometry().getExtent();
        var layer_name = feature.getId().split(".")[0];
        var id_feature = feature.getId().split(".")[1];

        // Pdm analyze info
        myTerritorialManagement._pdmAnalyzeInfo = {
            geom_wkt: geom_wkt,
            geom_extent: geom_extent.toString(),
            geom_srid: srid,
            id_user: idUser,
            id_map: myTerritorialManagement._mapSgs._settings._mapSettings.map_info.id,
            id_pdm_request_type: -1, // Do all
            layer_name: layer_name,
            id_feature: id_feature
        }

        $.ajax({
            type: 'POST',
            url: '/rest/app/TerritorialManagement/ExecutePdmAnalyze',
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(myTerritorialManagement._pdmAnalyzeInfo),
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao submeter o pedido");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // Show modal
                            $('#id-modal-pdm-analyze-entity-result').show();

                            // -- Build information layer --

                            // Layer with article
                            var countElement = data.result.list_answer_layer_info.length;
                            var hashForOrder = {};
                            var arrayTableArticle = [];
                            var hashEntity = {};
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.list_answer_layer_info[i];
                                var key = objEvent.layer_name;
                                if(!(hashForOrder[key] >= 0)) {
                                    arrayTableArticle.push({
                                        id_pdm_layer: objEvent.id_pdm_layer,
                                        layer_name: objEvent.layer_name,
                                        code_ref_pdm_request_type: objEvent.code_ref_pdm_request_type
                                    });
                                    hashForOrder[key] = arrayTableArticle.length - 1;
                                    if(objEvent.description_entity) {
                                        hashEntity[objEvent.description_entity] = 1;
                                    }
                                }
                            }

                            // Add layer with no article
                            var countLayerNoArticle = data.result.list_answer_layer_no_article_info.length;
                            for( var q = 0; q < countLayerNoArticle; q++) {
                                var objLayerNoArticle = data.result.list_answer_layer_no_article_info[q];
                                arrayTableArticle.push({
                                    id_pdm_layer: objLayerNoArticle.id_pdm_layer,
                                    layer_name: objLayerNoArticle.layer_name,
                                    code_ref_pdm_request_type: objLayerNoArticle.code_ref_pdm_request_type
                                });
                                if(objLayerNoArticle.description_entity) {
                                    hashEntity[objLayerNoArticle.description_entity] = 1;
                                }
                            }

                            for (let y = 0; y < arrayTableArticle.length; y++) {
                                var objEvent = arrayTableArticle[y];
                                $('#id-modal-pdm-analyze-entity-result-layer ul').append($('<li>' + objEvent.layer_name + '</li>'))
                            }

                            // -- Build entity information --
                            for( var t = 0; t < Object.keys(hashEntity).length; t++) {
                                var descriptionEntity = Object.keys(hashEntity)[t];
                                $('#id-modal-pdm-analyze-entity-result-entity ul').append($('<li>' + descriptionEntity + '</li>'))
                            }

                            break;
                        default:
                            toastr["error"]("Erro  o pedido");
                    }
                }

                // Stop wait
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao submeter o pedido");

                // Stop wait
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    };

    /**
     * Build location plant report
     * @param {int} id, id of the location plant
     */
    this.BuildLocationPlantReport = function (id)
    {
        var singleLegend = (myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "LEGEND_FORMAT").value === 'SINGLE_LEGEND')? true : false;
        var templateSelected = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "TEMPLATE_SELECT").value;
        var templatePosFixName = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "TEMPLATE_POSFIX_NAME").value;

        $.ajax({
            type: 'GET',
            url: '/rest/app/TerritorialManagement/GetLocationPlantById?id=' + id,
            contentType: "application/json",
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da planta de localização");

                    // Stop wait
                    myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                }
                else
                {
                    switch (data.result.status) {
                        case "SUCCESS":
                            var locationPlant = data.result.location_plant;
                            myTerritorialManagement._locationPlantProcessNumber = (locationPlant.process_number !== null) ? locationPlant.process_number.replace("/", "-"):"";
                            var locationPlantLp = data.result.location_plant_lp;
                            var locationPlantCe = data.result.location_plant_cartography_extract;
                            var locationPlantPdmo = data.result.location_plant_pdmo;
                            var locationPlantPdmc = data.result.location_plant_pdmc;
                            var locationPlantPdmr = data.result.location_plant_pdmr;
                            var locationPlantPdmpp = data.result.location_plant_pdmpp;
                            var polygon = locationPlant.geom_wkt;
                            var geom = new WKT().readGeometry(polygon);
                            var extent = geom.getExtent();      
                            var center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
                            var templateSelected = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "TEMPLATE_SELECT").value;
                            var templateDefault = (templateSelected === 'TEMPLATE_DEFAULT')? true: false;
                            var useInternalGeoserver = (templateSelected === 'TEMPLATE_PDF')? true: false;
                            var displayMapWidth =  parseInt(myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", templateSelected, "WIDTH").value);
                            var displayMapHeight = parseInt(myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", templateSelected, "HEIGHT").value);
                            var infoSystemCoordinate = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "SYSTEM_COORDINATE_DESC");
                            var locationPlantTemplateInfo = {
                                info: locationPlant,
                                lp_info: null,
                                lp_ce_info: [],
                                lp_pdmo_info: locationPlantPdmo,
                                lp_pdmc_info: locationPlantPdmc,
                                lp_pdmr_info: locationPlantPdmr,
                                lp_pdmpp_info: locationPlantPdmpp
                            }
                            var layerRequests = [];
                            var locationPlantCeDefinition = [];
                            var locationPlantCeDefinitionLayer = [];
                            
                            // Clean
                            myTerritorialManagement._hashPlantMap = {};

                            // Build extra info map bottom
                            if(templateDefault) {
                                if(locationPlant.is_public)
                                    $('.map-location-plant-extra-info-map-botton').html(_locationPlantExtraInfoMapBottomPublic);
                                else
                                    $('.map-location-plant-extra-info-map-botton').html(_locationPlantExtraInfoMapBottomPrivate);
                            }

                            // For legend purpose
                            var completeLayerArray = [];

                            // -- Location Plant --------------------------------------------------
                            if (locationPlantLp) {

                                if(templateDefault) {
                                    // -- Fill location plant information --
                                    for (var j = 0; j < Object.keys(locationPlant).length; j++) {
                                        var key = Object.keys(locationPlant)[j];
                                        var value = null;
                                        switch(key) {
                                            case "date_issue":
                                                value = myTerritorialManagement._utility.TransformDateServerInDateII(locationPlant[key]);
                                                break;
                                            default:
                                                value = locationPlant[key];
                                        }
                                        if ($("#location-plant-report-page-form [name='" + key + "'").length > 0 && value !== null)
                                            $("#location-plant-report-page-form [name='" + key + "'")[0].innerHTML = value;
                                    }

                                    // -- Fill footer map info --
                                    $('#location-plant-report-page .map-location-plant-system-coordinate-description')[0].innerHTML = infoSystemCoordinate.value;
                                    if(locationPlantLp.info_json) {
                                        var priceInfo = JSON.parse(locationPlantLp.info_json).price_value_info;
                                        if(priceInfo) {
                                            $('#location-plant-report-page .map-location-plant-extra-info-map-botton-zone').show();
                                            $('#location-plant-report-page .map-location-plant-extra-info-map-botton')[0].innerHTML = priceInfo;
                                        }
                                    }
                                }

                                // -- Build Map --
                                //var arrayIdLayerMetadata = locationPlantLp.array_id_layer_metadata.split(',').map(function (i) { return parseInt(i, 10) }).sort
                                var arrayIdLayerMetadata = locationPlantLp.array_id_layer_metadata.split(',').map(function (i) { return i.split(':')[0] }).sort();
                                var layersUrl = '/rest/app/TerritorialManagement/GetLocationPlantConfigInfoWithLayer?idLocationPlantDefinition=' + locationPlantLp.id_location_plant_definition;
                                for (var i = 0; i < arrayIdLayerMetadata.length; i++) {
                                    var param = '&ids=' + arrayIdLayerMetadata[i];
                                    layersUrl += layersUrl.indexOf(param) >= 0 ? '' : param;
                                }

                                layerRequests.push($.ajax({
                                    type: 'GET',
                                    url: layersUrl,
                                    dataType: 'json',
                                    async: false,
                                    success: function (data) {
                                        if (data.error) {
                                            toastr["error"]("Erro na construção do relatório");
                                        } else {
                                            var arrayLayer = data.result.listLayerInfo;
                                            var locationPlantDefinition = data.result.locationPlantDefinition;
                                            locationPlantTemplateInfo.lp_info = {
                                                map_image: null,
                                                config: null,
                                                layer_info_legend: []
                                            };

                                            // Location plant configuration information for template
                                            locationPlantTemplateInfo.lp_info.config = {
                                                "type": "Lp",
                                                "definitionInfo": locationPlantDefinition
                                            };

                                            if (arrayLayer.length) {
                                                var mapImageUrl = myTerritorialManagement._GetMapUrl(true, arrayLayer, id, "id", "vw_location_plant_display", _sridMap, locationPlantLp.scale, center, displayMapWidth, displayMapHeight, useInternalGeoserver, "", locationPlantDefinition.extract_from_geotiff, locationPlantDefinition.path_geotiff, locationPlantDefinition.use_base_layer, locationPlantDefinition.srs_srid);
                                                //if (!useInternalGeoserver && mapImageUrl.length > 800)
                                                //    mapImageUrl = myTerritorialManagement._GetMapUrl(arrayLayer, id, "id", "vw_location_plant_display", _sridMap, locationPlantLp.scale, center, displayMapWidth, displayMapHeight, true);
                                                
                                               $('#id-map-location-plant .map-img').attr("src", mapImageUrl);
                                               
                                                // Location plant image map URL for template
                                                locationPlantTemplateInfo.lp_info.map_image = {
                                                    "type": "Lp",
                                                    "image": mapImageUrl
                                                };

                                                // Location plant Layer legend URL for template 
                                                locationPlantTemplateInfo.lp_info.layer_info_legend = [];
                                                for (var i = 0; i < arrayLayer.length; i++) {
                                                    locationPlantTemplateInfo.lp_info.layer_info_legend.push({
                                                        "name": arrayLayer[i].text,
                                                        "url": arrayLayer[i].legendInternalUrl,
                                                        "parent": arrayLayer[i].layerParentName
                                                    });
                                                }
                                            }

                                            // set scale in report
                                            if(templateDefault) {
                                                var posScale = myTerritorialManagement._settings.scales.indexOf(locationPlantLp.scale);
                                                $('#location-plant-report-page .scale')[0].innerHTML = myTerritorialManagement._settings.scales[posScale];
                                            }

                                            // -- Legend --
                                            var legendInfo = _configurationInfo.locationPlantDefinitionInfo.find(c=> c.id == locationPlantLp.id_location_plant_definition);
                                            switch(legendInfo.cod_legend_type) {
                                                case "LEGEND_STYLE":
                                                    var legendArea = JSON.parse(JSON.stringify(arrayLayer[0]));
                                                    var layerAreaLabel = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "LAYER_AREA_LABEL").value;
                                                    var layerAreaStyle = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "LAYER_AREA_STYLE").value;
                                                    legendArea.legendUrl = legendArea.legendUrl.replace(legendArea.workspace + ":" + legendArea.sldName.replace('.sld', ''), layerAreaStyle);
                                                    legendArea.legendInternalUrl = legendArea.legendInternalUrl.replace(legendArea.workspace + ":" + legendArea.sldName.replace('.sld', ''), layerAreaStyle);
                                                    legendArea.text = layerAreaLabel;
                                                    arrayLayer.unshift(legendArea);

                                                    // Location plant Layer legend URL for template - polygon legend
                                                    locationPlantTemplateInfo.lp_info.layer_info_legend.push({
                                                        "name": legendArea.text,
                                                        "url": legendArea.legendInternalUrl,
                                                        "parent": legendArea.layerParentName
                                                    });

                                                    // For single legend
                                                    if(templateDefault) {
                                                        if (singleLegend) {
                                                            for (var i = 0; i < arrayLayer.length; i++) {
                                                                if (typeof completeLayerArray.find(x => x.text === arrayLayer[i].text) == "undefined") {
                                                                    completeLayerArray.push(arrayLayer[i]);
                                                                }
                                                            }
                                                        }
                                                        else
                                                        {
                                                            var arrayLayerList = [arrayLayer];
                                                            var pointer = 0;
                                                            while (arrayLayerList[pointer].length > 52) {
                                                                var secondArray = arrayLayerList[pointer].splice(53, (arrayLayerList[pointer].length - 1));
                                                                var firstArray = arrayLayerList[pointer].splice(0, 52);
                                                                arrayLayerList[pointer] = firstArray;
                                                                arrayLayerList[pointer + 1] = secondArray;
                                                                pointer++;
                                                            }

                                                            for (var legPage = 0; legPage < arrayLayerList.length; legPage++) {

                                                                var clonePageLegend = $('#legend-report').clone();
                                                                var idPageLegend = "legend-report-" + locationPlantLp.id_location_plant_definition + legPage;
                                                                clonePageLegend.attr("id", idPageLegend);
                                                                clonePageLegend.insertAfter('#location-plant-report-page');
                                                                $("#" + idPageLegend + " .header-plant-title-classic label")[0].innerHTML = "Legenda Planta de Localização";
                                                                //var arrayLayerRight = arrayLayer;
                                                                var arrayLayerRight = arrayLayerList[legPage];
                                                                var arrayLayerLeft = arrayLayerRight.splice(0, Math.ceil(arrayLayerRight.length / 2));

                                                                var layerTreeLegendLeft = {
                                                                    primaryKey: 'id',
                                                                    uiLibrary: 'materialdesign',
                                                                    imageUrlField: 'legendUrl',
                                                                    dataSource: arrayLayerLeft,
                                                                    checkboxes: false
                                                                };
                                                                $("#" + idPageLegend + " .legend-tree-zone-left").tree(layerTreeLegendLeft);

                                                                var layerTreeLegendRight = {
                                                                    primaryKey: 'id',
                                                                    uiLibrary: 'materialdesign',
                                                                    imageUrlField: 'legendUrl',
                                                                    dataSource: arrayLayerRight,
                                                                    checkboxes: false
                                                                };
                                                                $("#" + idPageLegend + " .legend-tree-zone-right").tree(layerTreeLegendRight);

                                                                $("#" + idPageLegend + " .legend-tree-zone").show();

                                                                clonePageLegend.toggle('ol-hidden');

                                                            }
                                                        }
                                                    }
                                                    break;
                                                default:
                                                    // do nothing
                                            }

                                            // Stop wait
                                            //myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                        }
                                    },
                                    error: function (request, status, error) {
                                        toastr["error"]("Erro na construção do relatório");
                                        // Stop wait
                                        //myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    }
                                }));
                            }
                            else {
                                if(templateDefault) {
                                    $('#location-plant-report-page').attr("style", "display:none;");
                                }
                            }

                            // -- Cartography extract ---------------------------------------------
                            for (var t = 0; t < locationPlantCe.length; t++)
                            {
                                var idBaseLayer = locationPlantCe[t].id_base_layer;
                                var scale = locationPlantCe[t].scale;
                                var isPdm = locationPlantCe[t].is_pdm;
                                var idLocationPlantDefinition = locationPlantCe[t].id_location_plant_definition;
                                var ceType = "Ce" + (t + 1);
                                locationPlantTemplateInfo.lp_ce_info.push({
                                    map_image: null,
                                    config: null,
                                    layer_info_legend: []
                                });

                                if(templateDefault) {
                                    var clonePageCartogray = $('#cartography-extract-report').clone();
                                    var idPage = "cartography-extract-report-" + idBaseLayer;
                                    clonePageCartogray.attr("id", idPage);
                                    $('#body-report').append(clonePageCartogray);
                                    var idForm = "cartography-extract-report-form-" + idBaseLayer;
                                    clonePageCartogray.find("#cartography-extract-report-form").attr("id", idForm);
                                    var idMap = "id-map-cartography-extract-" + idBaseLayer;
                                    clonePageCartogray.find("#id-map-cartography-extract").attr("id", idMap);
                                    clonePageCartogray.find("#id-map-cartography-extract-legend-img").attr("id", "id-map-cartography-extract-legend-img-" + idBaseLayer);

                                    // -- Fill footer map info --
                                    $('#' + idPage + ' .map-location-plant-system-coordinate-description')[0].innerHTML = infoSystemCoordinate.value;
                                    if(locationPlantCe[t].info_json) {
                                        var priceInfo = JSON.parse(locationPlantCe[t].info_json).price_value_info;
                                        if(priceInfo) {
                                            $('#' + idPage + ' .map-location-plant-extra-info-map-botton-zone').show();
                                            $('#' + idPage + ' .map-location-plant-extra-info-map-botton')[0].innerHTML = priceInfo;
                                        }
                                    }

                                    // Fill location plant information
                                    for (var j = 0; j < Object.keys(locationPlant).length; j++) {
                                        var key = Object.keys(locationPlant)[j];
                                        var value = null;
                                        switch(key) {
                                            case "date_issue":
                                                value = myTerritorialManagement._utility.TransformDateServerInDateII(locationPlant[key]);
                                                break;
                                            default:
                                                value = locationPlant[key];
                                        }
                                        if ($("#" + idForm +  " [name='" + key + "'").length > 0 && value !== null)
                                            $("#" + idForm + " [name='" + key + "'")[0].innerHTML = value;
                                    }

                                    // Show element
                                    clonePageCartogray.toggle('ol-hidden');
                                }

                                layerRequests.push($.ajax({
                                    type: 'GET',
                                    //url: '/rest/app/Layer/GetBaseLayerID?idBaseLayer=' + idBaseLayer,
                                    url: '/rest/app/TerritorialManagement/GetLocationPlantConfigInfoWithLayerSource?idLocationPlantDefinition=' + idLocationPlantDefinition + '&idLayerSource=' + idBaseLayer,
                                    dataType: 'json',
                                    async: false,
                                    success: function (data) {
                                        if (data.error) {
                                            toastr["error"]("Erro na construção do relatório");
                                        } else {
                                            switch(data.result.status) {
                                                case "ERROR":
                                                    toastr["error"]("Erro na construção do relatório");
                                                    break;
                                                case "SUCCESS":
                                                    var arrayLayer = [data.result.listLayerInfo];

                                                    // Detail under scale
                                                    var existLayerDetail = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "EXIST_LAYER_DETAIL");
                                                    var existLayerDetailValue = false;
                                                    if(existLayerDetail !== undefined)
                                                        existLayerDetailValue = existLayerDetail.value
                                                    if(existLayerDetailValue && scale <= 2000)
                                                        arrayLayer[0].layerName = arrayLayer[0].layerName + "Detail";

                                                    var locationPlantDefinition = data.result.locationPlantDefinition;
                                                    locationPlantCeDefinition.push(data.result.locationPlantDefinition);
                                                    locationPlantCeDefinitionLayer.push(data.result.locationPlantDefinitionLayer);

                                                    // Location plant configuration information for template
                                                    locationPlantTemplateInfo.lp_ce_info[t].config = {
                                                        "type": ceType,
                                                        "definitionInfo": locationPlantCeDefinition[t]
                                                    };

                                                    // Build url geoserver to get image map
                                                    if (arrayLayer.length) {
                                                        var mapImageUrl = myTerritorialManagement._GetMapUrl(true, arrayLayer, id, "id", "vw_location_plant_display", _sridMap, scale, center, displayMapWidth, displayMapHeight, useInternalGeoserver, "", locationPlantDefinition.extract_from_geotiff, locationPlantDefinition.path_geotiff, locationPlantDefinition.use_base_layer, locationPlantDefinition.srs_srid);
                                                        //if (!useInternalGeoserver && mapImageUrl.length > 800) 
                                                        //    mapImageUrl = myTerritorialManagement._GetMapUrl(arrayLayer, id, "id", "vw_location_plant_display", _sridMap, scale, center, displayMapWidth, displayMapHeight, true);

                                                        $('#' + idMap + ' .map-img').attr("src", mapImageUrl);

                                                        // Location plant image map URL for template
                                                        locationPlantTemplateInfo.lp_ce_info[t].map_image = {
                                                            "type": ceType,
                                                            "image": mapImageUrl
                                                        };

                                                        // Location plant Layer legend URL for template 
                                                        for (var p = 0; p < locationPlantCeDefinitionLayer[t].length; p++) {
                                                            locationPlantTemplateInfo.lp_ce_info[t].layer_info_legend.push({
                                                                "name": locationPlantCeDefinitionLayer[t][p].text,
                                                                "url": locationPlantCeDefinitionLayer[t][p].legendInternalUrl,
                                                                "parent": locationPlantCeDefinitionLayer[t][p].layerParentName
                                                            });
                                                        }
                                                    }

                                                    // set scale in report
                                                    if(templateDefault) {
                                                        var posScale = myTerritorialManagement._settings.scales.indexOf(scale);
                                                        $('#' + idPage + ' .scale')[0].innerHTML = myTerritorialManagement._settings.scales[posScale];

                                                        // Description
                                                        $("#" + idPage + " .cartography-base")[0].innerHTML = locationPlantCeDefinition[t].label;
                                                        $("#" + idPage + " .header-plant-title-classic label")[0].innerHTML = "PLANTA CARTOGRÁFICA - " + locationPlantCeDefinition[t].label;
                                                    }

                                                    // -- Legend --
                                                    //var legendInfo = _configurationInfo.locationPlantDefinitionInfo.find(c=> c.id == locationPlantLp.id_location_plant_definition);
                                                    switch(locationPlantCeDefinition[t].cod_legend_type) {
                                                        case "LEGEND_STYLE_GROUP":
                                                            var legendArea = JSON.parse(JSON.stringify(locationPlantCeDefinitionLayer[t][0]));
                                                            var layerAreaLabel = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "LAYER_AREA_LABEL").value;
                                                            var layerAreaStyle = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "LAYER_AREA_STYLE").value;
                                                            legendArea.legendUrl = ((useInternalGeoserver)? legendArea.internalGeoserver:legendArea.geoserver)
                                                            + "/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=24&HEIGHT=24&LAYER=legend:legend_" + legendArea.geom_type
                                                            + (layerAreaStyle != null ? "&STYLE=" + layerAreaStyle.replace(".sld", "") : "&STYLE=" + legendArea.geom_type)
                                                            + "&legend_options=fontColor:0xffffff;fontSize:1&FORMAT=image/png&TRANSPARENT=TRUE";
                                                            legendArea.text = layerAreaLabel;
                                                            locationPlantCeDefinitionLayer[t].unshift(legendArea);

                                                            // Location plant Layer legend URL for template - polygon legend
                                                            locationPlantTemplateInfo.lp_ce_info[t].layer_info_legend.push({
                                                                "name": legendArea.text,
                                                                "url": legendArea.legendUrl,
                                                                "parent": legendArea.layerParentName
                                                            });

                                                            if(templateDefault) {
                                                                if (singleLegend) {
                                                                    for (var i = 0; i < locationPlantCeDefinitionLayer[t].length; i++) {
                                                                        if (typeof completeLayerArray.find(x => x.text === locationPlantCeDefinitionLayer[t][i].text) == "undefined") {
                                                                            completeLayerArray.push(locationPlantCeDefinitionLayer[t][i]);
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    var clonePageLegend = $('#legend-report').clone();
                                                                    var idPageLegend = "legend-report-" + locationPlantCeDefinition[t].id;
                                                                    clonePageLegend.attr("id", idPageLegend);
                                                                    clonePageLegend.insertAfter('#' + idPage);
                                                                    $("#" + idPageLegend + " .header-plant-title-classic label")[0].innerHTML = "Legenda " + locationPlantCeDefinition[t].label;
                                                                    var arrayLayerRight = locationPlantCeDefinitionLayer[t];
                                                                    var arrayLayerLeft = arrayLayerRight.splice(0, Math.ceil(arrayLayerRight.length / 2));
                                                    
                                                                    var layerTreeLegendLeft = {
                                                                        primaryKey: 'id',
                                                                        uiLibrary: 'materialdesign',
                                                                        imageUrlField: 'legendUrl',
                                                                        dataSource: arrayLayerLeft,
                                                                        checkboxes: false
                                                                    };
                                                                    $("#" + idPageLegend + " .legend-tree-zone-left").tree(layerTreeLegendLeft);

                                                                    var layerTreeLegendRight = {
                                                                        primaryKey: 'id',
                                                                        uiLibrary: 'materialdesign',
                                                                        imageUrlField: 'legendUrl',
                                                                        dataSource: arrayLayerRight,
                                                                        checkboxes: false
                                                                    };
                                                                    $("#" + idPageLegend + " .legend-tree-zone-right").tree(layerTreeLegendRight);
  
                                                                    $("#" + idPageLegend + " .legend-tree-zone").show();

                                                                    clonePageLegend.toggle('ol-hidden');
                                                                }
                                                            }
                                                            break;
                                                        case "LEGEND_IMG":
                                                            if(templateDefault) {
                                                                $("#" + idPage + " .header-plant-title-classic label")[0].innerHTML = locationPlantCeDefinition[t].label;
                                                                $("#" + idPage + " .map-cartography-extract-base-info").hide();
                                                                $("#" + idPage + " .cartography-extract-footer-classic").toggleClass('with-cartography-info with-not-cartography-info')
                                                                // Image legend if exists
                                                                var imgLegendUrl = "";
                                                                if(_client === "ESPOSENDE")
                                                                    imgLegendUrl = "/images/" + layers[0].layerName + "_legend.png";
                                                                else
                                                                    imgLegendUrl = "/images/" + locationPlantCeDefinition[t].legend_image_name;
                                                                var clonePageLegend = $('#legend-report').clone();
                                                                var idPageLegend = "legend-report-" + idBaseLayer;
                                                                clonePageLegend.attr("id", idPageLegend);
                                                                clonePageLegend.insertAfter('#' + idPage);
                                                                $("#" + idPageLegend + " .header-plant-title-classic label")[0].innerHTML = "Legenda " + locationPlantCeDefinition[t].label;

                                                                $("#" + idPageLegend + " .legend-zone img").attr('src', imgLegendUrl);

                                                                $("#" + idPageLegend + " .legend-zone").show();
                                                                clonePageLegend.toggle('ol-hidden');
                                                            }
                                                            break;
                                                        default:
                                                            // do nothing
                                                    }

                                                    break;
                                                default:
                                            }

                                            // Stop wait
                                            //myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                        }
                                    },
                                    error: function (request, status, error) {
                                        // Stop wait
                                        //myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    }
                                }));
                            }

                            if(templateDefault) {
                                if (singleLegend && completeLayerArray.length > 0) {
                                    // New legend page in the end
                                    var clonePageLegend = $('#legend-report').clone();
                                    var idPageLegend = "legend-report";
                                    clonePageLegend.attr("id", idPageLegend);
                                    $('#body-report').append(clonePageLegend);
                                    $("#" + idPageLegend + " .header-plant-title-classic label")[0].innerHTML = "Legenda";
                                    var arrayLayerRight = completeLayerArray;
                                    var arrayLayerLeft = arrayLayerRight.splice(0, Math.ceil(arrayLayerRight.length / 2));

                                    var layerTreeLegendLeft = {
                                        primaryKey: 'id',
                                        uiLibrary: 'materialdesign',
                                        imageUrlField: 'legendUrl',
                                        dataSource: arrayLayerLeft,
                                        checkboxes: false
                                    };
                                    $("#" + idPageLegend + " .legend-tree-zone-left").tree(layerTreeLegendLeft);

                                    var layerTreeLegendRight = {
                                        primaryKey: 'id',
                                        uiLibrary: 'materialdesign',
                                        imageUrlField: 'legendUrl',
                                        dataSource: arrayLayerRight,
                                        checkboxes: false
                                    };
                                    $("#" + idPageLegend + " .legend-tree-zone-right").tree(layerTreeLegendRight);

                                    $("#" + idPageLegend + " .legend-tree-zone").show();

                                    clonePageLegend.toggle('ol-hidden');
                                }
                            }

                            // When layer and images are finished being fetched
                            if(templateSelected === 'TEMPLATE_PDF') {
                                $.when.apply($, layerRequests).done( function() {
                                
                                    // Build data for pdf build
                                    var lpImages = [];
                                    var lpDefinition = [];
                                    var lpLayers = [];
                                
                                    if(locationPlantTemplateInfo.lp_info) {
                                        lpImages.push(locationPlantTemplateInfo.lp_info.map_image);
                                        lpDefinition.push(locationPlantTemplateInfo.lp_info.config);
                                        lpLayers.push({ "type": "Lp", "layerInfo": locationPlantTemplateInfo.lp_info.layer_info_legend })
                                    }
                                    for(var a = 0; a < locationPlantTemplateInfo.lp_ce_info.length; a++) {
                                        var ceObj = locationPlantTemplateInfo.lp_ce_info[a];
                                        lpImages.push(ceObj.map_image);
                                        lpDefinition.push(ceObj.config);
                                        lpLayers.push({ "type": ceObj.map_image.type, "layerInfo": ceObj.layer_info_legend })
                                    }
                                
                                    var postData = JSON.stringify({
                                        templatePosFixName: templatePosFixName,
                                        locationPlantId: id,
                                        srid: infoSystemCoordinate.value,
                                        locationPlantInfo: locationPlant,
                                        locationPlantLp: locationPlantLp,
                                        locationPlantCe: locationPlantCe,
                                        locationPlantPdmo: locationPlantPdmo,
                                        locationPlantPdmc: locationPlantPdmc,
                                        locationPlantPdmr: locationPlantPdmr,
                                        images: lpImages,
                                        layers: lpLayers,
                                        legends: lpDefinition,
                                        locationPlantPlInfo: (locationPlantTemplateInfo.lp_info)? locationPlantTemplateInfo.lp_info.config.definitionInfo: null,
                                        locationPlantCeInfo: locationPlantCeDefinition,
                                        locationPlantCeInfoLayer: locationPlantCeDefinitionLayer
                                    });

                                    var dataFormEl = $('#data-form');
                                    dataFormEl.find('#jsonData').val(postData);
                                    var form = dataFormEl[0];
                                    var formData = new FormData(form);

                                    // Request Report Generation
                                    $.ajax({
                                        type: 'POST',
                                        url: '/LocationPlant/GenerateReport',
                                        data: formData,
                                        processData: false,
                                        contentType: false,
                                        success: function (data) {
                                            if (data.error) {
                                                toastr["error"]("Erro na construção das plantas de localização");
                                            } else {
                                                switch(data.result.status) {
                                                    case "SUCCESS":
                                                        var attempts = 0;
                                                        var pdfUrl = "/templates/territorial_management/export/" + data.result.fileName;
                                                        var fileExists = false;
                                                        window['callAttempts'] = 0;
                                                        window['callFile'] = function () {

                                                            // Set download retry if report pdf still does not exist on server
                                                            setTimeout(function () {
                                                                fileExists = myTerritorialManagement._UrlExists(pdfUrl);
                                                                attempts++;
                                                        
                                                                if (myTerritorialManagement._UrlExists(pdfUrl)) {

                                                                    // Render PDF File 
                                                                    var openPdfDirect = true; // Alway open in PDF canvas (window.navigator.userAgent.toLowerCase().indexOf('firefox')>= 0);
                                                                    if(openPdfDirect ) {
                                                                        window.location.assign(pdfUrl);
                                                                        return;
                                                                    }
                                                                    var url = pdfUrl;
                                                                    var thePdf = null;
                                                                    var scale = 1.5;

                                                                    // Show report on print preview mode
                                                                    PDFJS.getDocument(url).promise.then(function (pdf) {
                                                                        thePdf = pdf;
                                                                        var viewer = document.getElementById('pdf-display');

                                                                        for (var page = 1; page <= pdf.numPages; page++) {
                                                                            var canvas = document.createElement("canvas");
                                                                            canvas.className = 'pdf-page-canvas';
                                                                            viewer.appendChild(canvas);
                                                                            renderPage(page, canvas);
                                                                        }
                                                                    });

                                                                    function renderPage(pageNumber, canvas) {
                                                                        thePdf.getPage(pageNumber).then(function (page) {
                                                                            var viewport = page.getViewport(scale);
                                                                            canvas.height = viewport.height;
                                                                            canvas.width = viewport.width;
                                                                            page.render({ canvasContext: canvas.getContext('2d'), viewport: viewport });
                                                                        });
                                                                    }
                                                                    attempts = 10;

                                                                    // Show button
                                                                    $('#id-plant-report-pdf-btn').show();
                                                                    $('#id-plant-report-print-btn').show();

                                                                    myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                                                } else {
                                                                    if (window['callAttempts'] < 20) {
                                                                        window['callAttempts']++;
                                                                        window['callFile']();
                                                                    }
                                                                }
                                                            }, (attempts > 0 ? 1000 : 1));
                                                        }
                                                        window['callFile']();
                                                        
                                                        // Print pdf button
                                                        $('#id-plant-report-print-btn').off('click').on('click', function () {
                                                            myTerritorialManagement._PrintPdf(pdfUrl);
                                                        });

                                                        // Download pdf button
                                                        $('#id-plant-report-pdf-btn').off('click').click(function () {
                                                            var link = document.createElement('a');
                                                            link.href = pdfUrl;
                                                            link.download = 'planta-localizacao-' + myTerritorialManagement._locationPlantProcessNumber + '.pdf';
                                                            link.dispatchEvent(new MouseEvent('click'));
                                                        });
                                                        break;
                                                    default:
                                                        toastr["error"]("Erro na construção das plantas de localização");
                                                        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                                }
                                            }
                                        },
                                        error: function (request, status, error) {
                                            toastr["error"]("Erro na construção das plantas de localização");
                                            myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                        }
                                    });
                                });
                            }

                            // -- Location Plant pdmo ---------------------------------------------
                            if(templateDefault) {
                                if (locationPlantPdmo && !locationPlantPdmo.is_pdm_cartography_extract) {
                                    // Title
                                    $('#location-plant-pdmo-report-page .header-plant-title-classic label')[0].innerHTML = "PLANTA DE LOCALIZAÇÃO - PDM Ordenamento";

                                    // Change map id
                                    $('#location-plant-pdmo-report-page .map-config')[0].id = "id-map-location-plant-pdmo";

                                    // Fill location plant information
                                    for (var j = 0; j < Object.keys(locationPlant).length; j++) {
                                        var key = Object.keys(locationPlantPdmo)[j];
                                        var value = null;
                                        switch(key) {
                                            case "date_issue":
                                                value = myTerritorialManagement._utility.TransformDateServerInDateII(locationPlant[key]);
                                                break;
                                            default:
                                                value = locationPlant[key];
                                        }
                                    
                                        if ($("#location-plant-pdmo-report-page .location-plant-pdm-report-page-form [name='" + key + "'").length > 0 && value !== null)
                                            $("#location-plant-pdmo-report-page .location-plant-pdm-report-page-form [name='" + key + "'")[0].innerHTML = value;
                                    }

                                    // build map & report
                                    myTerritorialManagement._BuildPdmAnalyzeReport(locationPlantPdmo.id_pdm_analyze_process, 'pdmo', locationPlant, locationPlantPdmo.scale, locationPlantPdmo.id_location_plant_definition);

                                    // Build Map
                                    //var arrayIdLayerMetadata = locationPlantPdmo.array_id_layer_metadata.split(',').map(function (i) { return parseInt(i, 10) }).sort();

                                    //var layersUrl = '/rest/app/Layer/GetLayersById?';
                                    //for (var i = 0; i < arrayIdLayerMetadata.length; i++) {
                                    //    var param = '&ids=' + arrayIdLayerMetadata[i];
                                    //    layersUrl += layersUrl.indexOf(param) >= 0 ? '' : param;
                                    //}

                                    //$.ajax({
                                    //    type: 'GET',
                                    //    url: layersUrl,
                                    //    dataType: 'json',
                                    //    async: false,
                                    //    success: function (data) {
                                    //        if (data.error) {
                                    //            toastr["error"]("Erro na construção do relatório");
                                    //        } else {
                                    //            var layers = data.result;

                                    //            myTerritorialManagement.InitMapForReport("id-map-location-plant-pdmo", "location-plant-pdmo-report-page", _sridMap, locationPlant, layers, locationPlantPdmo.scale);

                                    //            // Pdm Report
                                    //            var pdmObj = new Pdm();
                                    //            pdmObj._reportLocationPlant = true;
                                    //            pdmObj._pdmIdNode = "location-plant-pdmo-report-article-page";
                                    //            pdmObj.BuildPdmAnalyzeReport(locationPlantPdmo.id_pdm_request);

                                    //            // Stop wait
                                    //            myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    //        }
                                    //    },
                                    //    error: function (request, status, error) {
                                    //        toastr["error"]("Erro na construção do relatório");
                                    //        // Stop wait
                                    //        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    //    }
                                    //});
                                }
                                else {
                                    $('#location-plant-pdmo-report-page').attr("style", "display:none;");
                                    $('#location-plant-pdmo-report-article-page').attr("style", "display:none;");
                                }
                            }

                            // -- Location Plant pdmc ---------------------------------------------
                            if(templateDefault) {
                                if (locationPlantPdmc && !locationPlantPdmc.is_pdm_cartography_extract) {
                                    // Title
                                    $('#location-plant-pdmc-report-page .header-plant-title-classic label')[0].innerHTML = "PLANTA DE LOCALIZAÇÃO - PDM Condicionantes";

                                    // Change map id
                                    $('#location-plant-pdmc-report-page .map-config')[0].id = "id-map-location-plant-pdmc";

                                    // Fill location plant information
                                    for (var j = 0; j < Object.keys(locationPlant).length; j++) {
                                        var key = Object.keys(locationPlantPdmc)[j];
                                        var value = null;
                                        switch(key) {
                                            case "date_issue":
                                                value = myTerritorialManagement._utility.TransformDateServerInDateII(locationPlant[key]);
                                                break;
                                            default:
                                                value = locationPlant[key];
                                        }
                                    
                                        if ($("#location-plant-pdmc-report-page .location-plant-pdm-report-page-form [name='" + key + "'").length > 0 && value !== null)
                                            $("#location-plant-pdmc-report-page .location-plant-pdm-report-page-form [name='" + key + "'")[0].innerHTML = value;
                                    }

                                    // build map & report
                                    myTerritorialManagement._BuildPdmAnalyzeReport(locationPlantPdmc.id_pdm_analyze_process, 'pdmc', locationPlant, locationPlantPdmc.scale, locationPlantPdmc.id_location_plant_definition);

                                    // Build Map
                                    //if(locationPlantPdmc.array_id_layer_metadata !== "" ) {
                                    //    var arrayIdLayerMetadata = locationPlantPdmc.array_id_layer_metadata.replace(/, $/, "").split(',').map(function (i) { return parseInt(i, 10) }).sort();

                                    //    var layersUrl = '/rest/app/Layer/GetLayersById?';
                                    //    for (var i = 0; i < arrayIdLayerMetadata.length; i++) {
                                    //        var param = '&ids=' + arrayIdLayerMetadata[i];
                                    //        layersUrl += layersUrl.indexOf(param) >= 0 ? '' : param;
                                    //    }

                                    //    $.ajax({
                                    //        type: 'GET',
                                    //        url: layersUrl,
                                    //        dataType: 'json',
                                    //        async: false,
                                    //        success: function (data) {
                                    //            if (data.error) {
                                    //                toastr["error"]("Erro na construção do relatório");
                                    //            } else {
                                    //                var layers = data.result;
                                                
                                    //                // build map
                                    //                myTerritorialManagement.InitMapForReport("id-map-location-plant-pdmc", "location-plant-pdmc-report-page", _sridMap, locationPlant, layers, locationPlantPdmc.scale);

                                    //                // Pdm Report
                                    //                var pdmObj = new Pdm();
                                    //                pdmObj._reportLocationPlant = true;
                                    //                pdmObj._pdmIdNode = "location-plant-pdmc-report-article-page";
                                    //                pdmObj.InitReport(locationPlantPdmc.id_pdm_request);

                                    //                // Stop wait
                                    //                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    //            }
                                    //        },
                                    //        error: function (request, status, error) {
                                    //            toastr["error"]("Erro na construção do relatório");
                                    //            // Stop wait
                                    //            myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    //        }
                                    //    });
                                    //}
                                    //else {
                                    //    // build map
                                    //    myTerritorialManagement.InitMapForReport("id-map-location-plant-pdmc", "location-plant-pdmc-report-page", _sridMap, locationPlant, [], locationPlantPdmc.scale);

                                    //    // Pdm Report
                                    //    var pdmObj = new Pdm();
                                    //    pdmObj._reportLocationPlant = true;
                                    //    pdmObj._pdmIdNode = "location-plant-pdmc-report-article-page";
                                    //    pdmObj.InitReport(locationPlantPdmc.id_pdm_request);

                                    //    // Stop wait
                                    //    myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    //}
                                }
                                else {
                                    $('#location-plant-pdmc-report-page').attr("style", "display:none;");
                                    $('#location-plant-pdmc-report-article-page').attr("style", "display:none;");
                                }
                            }

                            // -- Location Plant pdmpp -------------------------------------------
                            if(templateDefault) {
                                if (locationPlantPdmpp && !locationPlantPdmpp.is_pdm_cartography_extract) {
                                    // Title
                                    $('#location-plant-pdmpp-report-page .header-plant-title-classic label')[0].innerHTML = "PLANTA DE LOCALIZAÇÃO - PDM Plano de Pormenor";

                                    // Change map id
                                    $('#location-plant-pdmpp-report-page .map-config')[0].id = "id-map-location-plant-pdmpp";

                                    // Fill location plant information
                                    for (var j = 0; j < Object.keys(locationPlant).length; j++) {
                                        var key = Object.keys(locationPlantPdmpp)[j];
                                        var value = null;
                                        switch(key) {
                                            case "date_issue":
                                                value = myTerritorialManagement._utility.TransformDateServerInDateII(locationPlant[key]);
                                                break;
                                            default:
                                                value = locationPlant[key];
                                        }
                                    
                                        if ($("#location-plant-pdmpp-report-page .location-plant-pdm-report-page-form [name='" + key + "'").length > 0 && value !== null)
                                            $("#location-plant-pdmpp-report-page .location-plant-pdm-report-page-form [name='" + key + "'")[0].innerHTML = value;
                                    }

                                    // build map & report
                                    myTerritorialManagement._BuildPdmAnalyzeReport(locationPlantPdmpp.id_pdm_analyze_process, 'pdmpp', locationPlant, locationPlantPdmpp.scale, locationPlantPdmpp.id_location_plant_definition);

                                    // Build Map
                                    //var arrayIdLayerMetadata = locationPlantPdmo.array_id_layer_metadata.split(',').map(function (i) { return parseInt(i, 10) }).sort();

                                    //var layersUrl = '/rest/app/Layer/GetLayersById?';
                                    //for (var i = 0; i < arrayIdLayerMetadata.length; i++) {
                                    //    var param = '&ids=' + arrayIdLayerMetadata[i];
                                    //    layersUrl += layersUrl.indexOf(param) >= 0 ? '' : param;
                                    //}

                                    //$.ajax({
                                    //    type: 'GET',
                                    //    url: layersUrl,
                                    //    dataType: 'json',
                                    //    async: false,
                                    //    success: function (data) {
                                    //        if (data.error) {
                                    //            toastr["error"]("Erro na construção do relatório");
                                    //        } else {
                                    //            var layers = data.result;

                                    //            myTerritorialManagement.InitMapForReport("id-map-location-plant-pdmo", "location-plant-pdmo-report-page", _sridMap, locationPlant, layers, locationPlantPdmo.scale);

                                    //            // Pdm Report
                                    //            var pdmObj = new Pdm();
                                    //            pdmObj._reportLocationPlant = true;
                                    //            pdmObj._pdmIdNode = "location-plant-pdmo-report-article-page";
                                    //            pdmObj.BuildPdmAnalyzeReport(locationPlantPdmo.id_pdm_request);

                                    //            // Stop wait
                                    //            myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    //        }
                                    //    },
                                    //    error: function (request, status, error) {
                                    //        toastr["error"]("Erro na construção do relatório");
                                    //        // Stop wait
                                    //        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
                                    //    }
                                    //});
                                }
                                else {
                                    $('#location-plant-pdmpp-report-page').attr("style", "display:none;");
                                    $('#location-plant-pdmpp-report-article-page').attr("style", "display:none;");
                                }
                            }

                            //toastr["success"]("Pedido efectuado com sucesso");
                            break;
                        default:
                            //toastr["error"]("Erro ao submeter o pedido");
                    }
                }

                // Stop wait
                //myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                //toastr["error"]("Erro ao submeter o pedido");

                // Stop wait
                myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    };

    /**
     * Create map ol for location plant
     * @param {string} idMapNode, map node id
     * @param {string} idScaleNode, scale node id
     * @param {string} srid, srid
     * @param {object} request, request
     * @param {array} layers, layers array
     */
    this.InitMapForReport = function (idMapNode, idScaleNode, srid, request, layers, scale, isBaseMap)
    {
        var mapLayers = [];

        proj4.defs("EPSG:" + srid, '+proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
        register(proj4);

        var projection = new Projection({
            code: 'EPSG:' + srid,
            units: 'm'
        });
        addProjection(projection);

        var geom = new WKT().readGeometry(request.geom_wkt);
        var extent = geom.getExtent();
        var center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
        var extentMap = eval(request.extent);

        var posScale = myTerritorialManagement._settings.scales.indexOf(scale);

        myTerritorialManagement._hashPlantMap[idMapNode] = new Map({
            controls: defaultControls({ constrainResolution: true, zoom: false, attribution: false }),
            interactions: defaultInteractions({
                doubleClickZoom: false,
                dragAndDrop: false,
                dragPan: false,
                keyboardPan: false,
                keyboardZoom: false,
                mouseWheelZoom: false,
                pointer: false,
                select: false
            }),
            layers: [],
            target: idMapNode,
            view: new View({
                center: center,
                projection: projection,
                resolutions: myTerritorialManagement._settings.resolutions,
                resolution: myTerritorialManagement._settings.resolutions[posScale]
            })
        });

        setTimeout(function () {
            myTerritorialManagement._hashPlantMap[idMapNode].updateSize();
        }, 3000);

        for (var l in layers) {
            var layer = layers[l];

            if(isBaseMap || layer.isBaseLayer) {
                if (myTerritorialManagement._resultWmtsGetCapabilities === null) {
                    myTerritorialManagement._GetCapabilitiesWmts(layer.workspace, layer.geoserver, layer.internalGeoserver);
                }

                var options = optionsFromCapabilities(myTerritorialManagement._resultWmtsGetCapabilities, {
                    layer: layer.layerName,
                    matrixSet: "EPSG:" + _sridMap
                });

                var tileLayer = new TileLayer({
                    name: layer.workspace + ":" + layer.layerName,
                    zIndex: -1,
                    visible: true,
                    source: new WMTS(/** @type {!module:ol/source/WMTS~Options} */(options))//,
                    //minResolution: minScale ? myTerritorialManagement._settings.resolutions[myTerritorialManagement._settings.scales.indexOf(minScale)] : myTerritorialManagement._settings.resolutions[myTerritorialManagement._settings.resolutions.length - 1],
                    //maxResolution: maxScale ? myTerritorialManagement._settings.resolutions[myTerritorialManagement._settings.scales.indexOf(maxScale)] : myTerritorialManagement._settings.resolutions[0]
                });

                // Add tile layer to array
                myTerritorialManagement._hashPlantMap[idMapNode].addLayer(tileLayer);
            }
            else {
                var params = { 'LAYERS': layer.workspace + ':' + layer.layerName, 'TILED': true, 'VERSION': '1.1.1' };
                if (layer.sldName)
                    params.STYLES = layer.workspace + ":" + layer.sldName.replace('.sld', '');
                if (layer.cqlFilter)
                    params.cql_filter = layer.cqlFilter; // + " and BBOX(geom, " + myTerritorialManagement._hashPlantMap[idMapNode].getView().calculateExtent().join(',') + ")";
                var tileLayer = new ImageLayer({
                    name: layer.workspace + ":" + layer.layerName,
                    source: new ImageWMS({
                        url: layer.geoserver + '/' + layer.workspace + '/wms',
                        params: params,
                        serverType: 'geoserver',
                        hidpi: false,
                        transition: 0
                    })
                });
                //mapLayers.push(tileLayer);
                myTerritorialManagement._hashPlantMap[idMapNode].addLayer(tileLayer);
            }
        }

        const styleGeom = new Style({
            fill: new Fill({
                color: _LocationPlantPolygonColorIn
            }),
            stroke: new Stroke({
                color: _LocationPlantPolygonColorOut,
                width: 2
            })
        });
        const styleGeom2 = new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 255, 1)',
                width: 5
            })
        });
        var feature = new Feature({
            geometry: geom
        });
        var vector = new VectorLayer({
            source: new VectorSource({
                features: [feature]
            }),
            style: [
                styleGeom2,
                styleGeom
            ]
        });
        myTerritorialManagement._hashPlantMap[idMapNode].addLayer(vector);

        // set scale in report
        $('#' + idScaleNode + ' .scale')[0].innerHTML = myTerritorialManagement._settings.scales[posScale];
    };

    /**
     * Build cartography extract option from layer base
     * @param {int} idLayerBase, layer base identifier
     * @param {string} label, label of the location plant
     * @param {string} arrayScale, scale array
     * @param {string} scaleSelectedDefault, scale selected by default
     * @param {string} idLocationPlantDefinition, location plant definition id
     * @param {bool} isPdm, indicate if base layer is use has pdm
     * @param {string} codePdmType, pdm type
     * @param {bool} isLocationPlant, indicate if base layer is use has location plant
     */
    this.BuildCartographyExtractOptionFromLayerBase = function (idLayerBase, label, arrayScale, scaleSelectedDefault, idLocationPlantDefinition, isPdm, codePdmType, isLocationPlant)
    {
        var idNodeParent = 'id-modal-location-plant-carto';
        var idInput = "id-modal-location-plant-carto-active-" + idLayerBase;
        var idLabel = "id-modal-location-plant-carto-active-label-" + idLayerBase;
        var idSelectScale = "id-modal-location-plant-carto-active-scale-" + idLayerBase;
        var idScaleDiv = "id-modal-location-plant-carto-active-scale-div-" + idLayerBase;

        var divElementRow = document.createElement('div');
        divElementRow.className = "row option-title-row";
        divElementRow.setAttribute("style", "border: none;");
        $('#' + idNodeParent)[0].appendChild(divElementRow);
        var divElementcolLeft = document.createElement('div');
        divElementcolLeft.className = "col-md-10";
        divElementcolLeft.setAttribute("style", "padding-left: 0px;");
        divElementRow.appendChild(divElementcolLeft);
        var labelElement = document.createElement('label');
        labelElement.id = idLabel;
        labelElement.className = "label-switch pull-left";
        labelElement.setAttribute("for", idInput);
        divElementcolLeft.appendChild(labelElement);
        var inputElement = document.createElement('input');
        inputElement.id = idInput;
        inputElement.className = "switch";
        inputElement.setAttribute("type", "checkbox");
        inputElement.setAttribute("base-layer-id", idLayerBase);
        inputElement.setAttribute("scale-select-id", idSelectScale);
        inputElement.setAttribute("scale-select-div-id", idScaleDiv);
        inputElement.setAttribute("location-plant-definition-id", idLocationPlantDefinition);
        labelElement.appendChild(inputElement);
        var spanElement = document.createElement('span');
        spanElement.className = "status";
        spanElement.setAttribute("style", "margin-left: 0px;");
        labelElement.appendChild(spanElement);
        var titleElement = document.createElement('span');
        titleElement.className = "modal-location-plant-active-title";
        titleElement.innerHTML = label;
        labelElement.appendChild(titleElement);
        var divElementcolRight = document.createElement('div');
        divElementcolRight.id = idScaleDiv;
        divElementcolRight.className = "col-md-2";
        divElementcolRight.setAttribute("style", "display: none");
        divElementRow.appendChild(divElementcolRight);
        var divSelectScaleElement = document.createElement('div');
        divSelectScaleElement.className = "modal-location-plant-active-select-scale";
        divElementcolRight.appendChild(divSelectScaleElement);
        var selectScaleElement = document.createElement('select');
        selectScaleElement.id = idSelectScale;
        selectScaleElement.name = "scales";
        selectScaleElement.className = "form-control"
        divSelectScaleElement.appendChild(selectScaleElement);
        // Fill select scale
        this._utility.SetScaleInSelect(idSelectScale, arrayScale, scaleSelectedDefault);

        // Event on active
        $('#' + idInput).on('change', function () {
            var idBaseLayer = $(this).attr("base-layer-id");
            var idSelectScale = $(this).attr("scale-select-id");
            var idScaleDiv = $(this).attr("scale-select-div-id");
            var idLocationPlantDefinition = $(this).attr("location-plant-definition-id");
            var infoJson = myTerritorialManagement._hashCartographyExtrac[idLocationPlantDefinition].info_json;

            if (this.checked) {
                myTerritorialManagement._hashOption.cartography_extract[idBaseLayer] = {"idSelectScale": idSelectScale, "idLocationPlantDefinition": idLocationPlantDefinition, "info_json": infoJson};
            }
            else {
                if (myTerritorialManagement._hashOption.cartography_extract[idBaseLayer])
                    delete myTerritorialManagement._hashOption.cartography_extract[idBaseLayer];
            }

            $("#" + idScaleDiv).toggle('ol-hidden');
        });
    }

    /**
     * Build location plant group option from layer base
     * @param {int} groupName, group name
     * @param {int} idNodeParent, layer base identifier
     * @param {int} idLayerBase, layer base identifier
     * @param {string} label, label of the location plant
     * @param {string} arrayScale, scale array
     * @param {string} scaleSelectedDefault, scale selected by default
     * @param {string} idLocationPlantDefinition, location plant definition id
     * @param {bool} isPdm, indicate if base layer is use has pdm
     * @param {string} codePdmType, pdm type
     * @param {bool} isLocationPlant, indicate if base layer is use has location plant
     * @param {bool} activeSelectionGroup, indicate if localtion plant group as active selection
     * @param {bool} activeSelection, indicate if localtion plant as active selection
     */
    this.BuildLocationPlantGroupOptionFromLayerBase = function (groupName, idNodeParent, idLayerBase, label, arrayScale, scaleSelectedDefault, idLocationPlantDefinition, isPdm, codePdmType, isLocationPlant, activeSelectionGroup, activeSelection)
    {
        var idInput = "id-modal-location-plant-group-active-" + groupName + "-" + scaleSelectedDefault + "-" + idLayerBase;
        var idLabel = "id-modal-location-plant-group-active-label-" + groupName + "-" + scaleSelectedDefault + "-"  + idLayerBase;
        var idSelectScale = "id-modal-location-plant-group-active-scale-" + groupName + "-" + scaleSelectedDefault + "-"  + idLayerBase;
        var idScaleDiv = "id-modal-location-plant-group-active-scale-div-" + groupName + "-" + scaleSelectedDefault + "-"  + idLayerBase;

        var divElementRow = document.createElement('div');
        divElementRow.className = "row option-title-row";
        divElementRow.setAttribute("style", "border: none;");
        $('#' + idNodeParent)[0].appendChild(divElementRow);
        var divElementcolLeft = document.createElement('div');
        divElementcolLeft.className = "col-md-10";
        divElementcolLeft.setAttribute("style", "padding-left: 0px;");
        divElementRow.appendChild(divElementcolLeft);
        var labelElement = document.createElement('label');
        labelElement.id = idLabel;
        labelElement.className = "label-switch pull-left";
        labelElement.setAttribute("for", idInput);
        divElementcolLeft.appendChild(labelElement);
        var inputElement = document.createElement('input');
        inputElement.id = idInput;
        inputElement.className = "switch";
        inputElement.setAttribute("type", "checkbox");
        inputElement.setAttribute("base-layer-id", idLayerBase);
        inputElement.setAttribute("scale-select-id", idSelectScale);
        inputElement.setAttribute("scale-select-div-id", idScaleDiv);
        inputElement.setAttribute("location-plant-definition-id", idLocationPlantDefinition);
        labelElement.appendChild(inputElement);
        var spanElement = document.createElement('span');
        spanElement.className = "status";
        spanElement.setAttribute("style", "margin-left: 0px;");
        labelElement.appendChild(spanElement);
        var titleElement = document.createElement('span');
        titleElement.className = "modal-location-plant-active-title location-plant";
        titleElement.innerHTML = label;
        labelElement.appendChild(titleElement);
        var divElementcolRight = document.createElement('div');
        divElementcolRight.id = idScaleDiv;
        divElementcolRight.className = "col-md-2";
        divElementcolRight.setAttribute("style", "display: none");
        divElementRow.appendChild(divElementcolRight);
        var divSelectScaleElement = document.createElement('div');
        divSelectScaleElement.className = "modal-location-plant-active-select-scale";
        divElementcolRight.appendChild(divSelectScaleElement);
        var selectScaleElement = document.createElement('select');
        selectScaleElement.id = idSelectScale;
        selectScaleElement.name = "scales";
        selectScaleElement.className = "form-control"
        divSelectScaleElement.appendChild(selectScaleElement);
        // Fill select scale
        this._utility.SetScaleInSelect(idSelectScale, arrayScale, scaleSelectedDefault);

        // Event on active
        $('#' + idInput).on('change', function () {
            var idBaseLayer = $(this).attr("base-layer-id");
            var idSelectScale = $(this).attr("scale-select-id");
            var idScaleDiv = $(this).attr("scale-select-div-id");
            var idLocationPlantDefinition = $(this).attr("location-plant-definition-id");
            var infoJson = myTerritorialManagement._hashLocationPlantGroup[idLocationPlantDefinition].info_json;

            if (this.checked) {
                myTerritorialManagement._hashOption.cartography_extract[idBaseLayer] = { "idSelectScale": idSelectScale, "scale": -1, "idLocationPlantDefinition": idLocationPlantDefinition, "info_json": infoJson };
            }
            else {
                if (myTerritorialManagement._hashOption.cartography_extract[idBaseLayer])
                    delete myTerritorialManagement._hashOption.cartography_extract[idBaseLayer];
            }

            $("#" + idScaleDiv).toggle('ol-hidden');
        });
    }

    /**
     * Generate pdf analyse pdm
     * @param {int} processNumber, process number
     * @param {array} arrayLayer, array of layer to apear in map
     */
    this.GeneratePdmAnalyzePdf = function (processNumber, arrayLayer) {
        var doc = new jsPDF("p", "px", "a4");

        doc.setFontSize(8);
        doc.text(300, 20, 'MUNICÍPIO DE PONTA DELGADA');//_headerTemplate.infoRightTitle);
        doc.text(300, 28, 'Praça do Município, 9504-523 Ponta Delgada');//_headerTemplate.infoRightAddress);
        doc.text(300, 34, _headerTemplate.infoRightEmail);
        doc.text(300, 42, '+351 296 304400'); //_headerTemplate.infoRightNumber);
        doc.text(300, 50, _headerTemplate.infoRightSite);

        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text(100, 20, 'Plano Director Municipal de Ponta Delgada');
        doc.text(140, 30, 'Entidades a consultar');
        
        doc.setFontSize(10);
        doc.setFontType("bold");
        doc.text(23.615, 50, 'Processo:');

        doc.setFontSize(10);
        doc.setFontType("normal");
        doc.text(65, 50, processNumber);

        doc.rect(23.615, 56.385, 399.23, 311.23);
        doc.rect(46.23, 79, 354, 266);

        var zone = "PTRA08 UTM Zone 26N";

        doc.setFontSize(8);
        doc.text(23.615, 375, "PTRA08 UTM Zone 26N");
        doc.text(380, 375, "1:10000");

        doc.setFontSize(12);
        doc.setFontType("bold");
        doc.text(23.615, 390, "Entidades a Consultar");
        var posY = 400;

        for(var i = 0; i < $('#id-modal-pdm-analyze-entity-result-entity ul li').length; i++) {
            var entity = $('#id-modal-pdm-analyze-entity-result-entity ul li')[i].innerHTML;
            doc.setFontSize(10);
            doc.setFontType("normal");
            doc.text(40, posY, entity);
            posY += 10; 
        }

        doc.setFontSize(12);
        doc.setFontType("bold");
        posY += 30;
        doc.text(23.615, posY, "Temas Intersectados");
        posY += 10;

        for(var j = 0; j < $('#id-modal-pdm-analyze-entity-result-layer ul li').length; j++) {
            var layerName = $('#id-modal-pdm-analyze-entity-result-layer ul li')[j].innerHTML;
            doc.setFontSize(10);
            doc.setFontType("normal");
            doc.text(40, posY, layerName);
            posY += 10; 
        }

        myTerritorialManagement._utility.ToDataUrl(_headerTemplate.ImageLogoLocationPlant, function(myBase64) {
            doc.addImage(
                myBase64,
                'JPEG',
                30,
                20,
                45,
                20,
                '',
                'SLOW'
            );

            var scale = 10000;
            var displayMapWidth = 800;
            var displayMapHeight = 600;
            //var center = [614770.317442384, 4180976.17915863];

            var extent = JSON.parse("[" + myTerritorialManagement._pdmAnalyzeInfo.geom_extent + "]");
            var center = [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
            var layerName = "VW_" + myTerritorialManagement._pdmAnalyzeInfo.layer_name;
            var idFeature = myTerritorialManagement._pdmAnalyzeInfo.id_feature;
            var idFieldName = "ID_SEARCH";
            var srid = myTerritorialManagement._mapSgs._settings._mapSettings.map_info.srs_srid.toString();

            var getMapUrl = myTerritorialManagement._GetMapUrl(false, arrayLayer, idFeature, idFieldName, layerName, srid, scale, center, displayMapWidth, displayMapHeight, false, 'jpeg');
            myTerritorialManagement._utility.ToDataUrl(getMapUrl, function(myBase64) {
            
                doc.addImage(
                    myBase64,
                    'JPEG',
                    47.23,
                    80,
                    352,
                    264,
                    '',
                    'SLOW'
                );

                doc.save("entidades-relatorio.pdf");
            });
        });
    }

    this.GeneratePdfLoactionPlant = function() {
        myTerritorialManagement.pdfObj = new jsPDF("p", "px", [794, 1122]);

        myTerritorialManagement._BuildPdfHeaderTemplate("PLANTA DE LOCALIZAÇÃO", 20);
        myTerritorialManagement._BuildPdfImageZone(20);
    
        myTerritorialManagement.pdfObj.save("download.pdf");
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------


    /**
     * Verify ir url exists
     * @param {string} url, url to by tested
     */
    this._UrlExists = function(url) {
        var http = new XMLHttpRequest();
        http.open('HEAD', url, false);
        http.send();
        return http.status != 404;
    }

    /**
     * Print pdf
     * @param {string} url, url of the pdf to by printed
     */
    this._PrintPdf = function(url) {
        var iframe;
        iframe = document.createElement('iframe');
        document.body.appendChild(iframe);

        iframe.style.display = 'none';
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();
            }, 1);
        };        

        iframe.src = url;
    }

    /**
     * Build pdf header Template
     * @param {string} title, title template
     * @param {float} marginLeft, margin left
     */
    this._BuildPdfHeaderTemplate = function(title, marginLeft) {

        myTerritorialManagement.pdfObj.setFontSize(8);
        myTerritorialManagement.pdfObj.setFontType("normal");
        myTerritorialManagement.pdfObj.text(300, 20, _headerTemplate.infoRightTitle);
        myTerritorialManagement.pdfObj.text(300, 28, _headerTemplate.infoRightAddress);
        myTerritorialManagement.pdfObj.text(300, 34, _headerTemplate.infoRightEmail);
        myTerritorialManagement.pdfObj.text(300, 42, _headerTemplate.infoRightNumber);
        myTerritorialManagement.pdfObj.text(300, 50, _headerTemplate.infoRightSite);
        
        myTerritorialManagement.pdfObj.setFontSize(10);
        myTerritorialManagement.pdfObj.setFontType("bold");
        myTerritorialManagement.pdfObj.text(marginLeft, 50, title);

        myTerritorialManagement._utility.ToDataUrl(_headerTemplate.ImageLogoLocationPlant, function(myBase64) {
            myTerritorialManagement.pdfObj.addImage(
                myBase64,
                'JPEG',
                30,
                20,
                45,
                20,
                '',
                'SLOW'
            );
        });

        //myTerritorialManagement._arrayAjaxRequest.push(
        //    $.ajax({
        //        url: myTerritorialManagement._headerTemplate.ImageLogoLocationPlant,
        //        xhrFields:{
        //            responseType: 'blob'
        //        },
        //        success: function (data) {
        //            var reader = new FileReader();
        //            reader.onloadend = function() {
        //                myTerritorialManagement.pdfObj.addImage(
        //                    reader.result;
        //                'JPEG',
        //                30,
        //                20,
        //                45,
        //                20,
        //                '',
        //                'SLOW'
        //                );
        //            }
        //            reader.readAsDataURL(data);
        //        }
        //    });
        //);
    }

    /**
     * Build pdf image zone
     */
    this._BuildPdfImageZone = function(marginLeft, zone, scale, extent) {

        // Image rectangle área
        myTerritorialManagement.pdfObj.rect(marginLeft, 56.385, 399.23, 311.23);
    }

    // Build pdf Location plante page
    this._BuildPageLocationPlant = function(title) {
        myTerritorialManagement.pdfObj.addPage();

        myTerritorialManagement._BuildPdfHeaderTemplate
    }

    /**
     * Get map url
     * @param {array} arrayLayer, array of layer information 
     * @param {int} idPolygon, polygon draw identifier
     * @param {int} idPolygonFieldName, polygon id field name
     * @param {string} layerPolygonName, polygon draw layer name
     * @param {string} sridMap, srid of the map
     * @param {string} scale, scale to be apply
     * @param {array} center, center of the map
     * @param {float} displayMapWidth, with image
     * @param {float} displayMapHeight, height image
     */
    this._GetMapUrl = function (useIdentify, arrayLayer, idPolygon, idPolygonFieldName, layerPolygonName, sridMap, scale, center, displayMapWidth, displayMapHeight,
                                useInternalGeoserver, formatType, extractFromGeotiff, path_Geotiff, useBaseLayer, srid) {
        var geoserverUrl = (useInternalGeoserver)? arrayLayer[0].internalGeoserver: arrayLayer[0].geoserver + "/";
        //var getMapUrl = geoserverUrl + arrayLayer[0].workspace + "/wms?service=WMS&version=1.1.1&request=GetMap";
        var getMapUrl = geoserverUrl + "/wms?service=WMS&version=1.1.1&request=GetMap";
        var layers = "";
        var layerInfo = [];
        var styles = "";
        var cqlFilter = "";
        var workspace = "";
        for (var k = 0; k < arrayLayer.length; k++) {
            if (k == 0 && extractFromGeotiff && !useBaseLayer)
                continue;
            layers += arrayLayer[k].workspace + ":" + arrayLayer[k].layerName + ",";
            cqlFilter += (arrayLayer[k].cqlFilter || "INCLUDE") + ";";
            styles += ((arrayLayer[0].sldName === undefined)? "":arrayLayer[k].sldName.replace('.sld', '')) + ",";
        }

        // Add polygon layer
        var workspaceInfo = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "URBANISM_TOOL", "LAYER_INFO_PROCESS", "WORKSPACE");
        var workspace = arrayLayer[0].workspace;
        if(workspaceInfo)
            workspace = workspaceInfo.value;

        layers += workspace + ":" + layerPolygonName;
        cqlFilter += idPolygonFieldName + "=" + idPolygon;

        // Add scale identify layer
        if (useIdentify) {
            const useCircleIdentifyObj = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "CIRCLE_IDENTIFY");
            if (useCircleIdentifyObj && useCircleIdentifyObj.value && useCircleIdentifyObj.value == "true") {

                // Get all scale available
                const scaleScaleIdentifyObj = myTerritorialManagement._utility.GetPropertyInfoInConfigArrayMulti(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "CIRCLE_IDENTIFY_SCALE");

                // Verify is scale existe in all the scale where identify polygon exists
                var isScale = false;
                if (scaleScaleIdentifyObj && scaleScaleIdentifyObj.length > 0) {
                    scaleScaleIdentifyObj.forEach(scaleInfo => {
                        if (parseInt(scaleInfo.value.split(",")[0]) === scale) {
                            isScale = true;
                        }
                    });
                }

                if (isScale) {
                    // Get layer info
                    const workspaceScaleIdentifyObj = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "CIRCLE_IDENTIFY_WORKSPACE");
                    const layerNameScaleIdentifyObj = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "CIRCLE_IDENTIFY_LAYER_NAME");
                    const columnNameIdScaleIdentifyObj = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "CIRCLE_IDENTIFY_COLUMN_NAME_ID");
                    if (workspaceScaleIdentifyObj && workspaceScaleIdentifyObj.value && layerNameScaleIdentifyObj && layerNameScaleIdentifyObj.value && columnNameIdScaleIdentifyObj && columnNameIdScaleIdentifyObj.value) {
                        layers += "," + workspaceScaleIdentifyObj.value + ":" + layerNameScaleIdentifyObj.value;
                        cqlFilter += ";" + columnNameIdScaleIdentifyObj.value + "=" + idPolygon + scale;
                        styles += ",";
                    }
                }
            }
        }

        var resolution = myTerritorialManagement._settings.resolutions[myTerritorialManagement._settings.scales.indexOf(scale)]

        // If Extract base map from geoTiff
        if (extractFromGeotiff) {
            // Get url extract geopTiff
            var urlExtractGeoTiff = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "TEMPLATE_INFO", "URL_EXTRACT_GEOTIFF");
            getMapUrl = urlExtractGeoTiff.value + "?";
            getMapUrl += "wms_url=" + geoserverUrl + "/wms";
            getMapUrl += "&srid=" + srid;
            getMapUrl += "&layers=" + layers;
            getMapUrl += "&cql_filter=" + cqlFilter;
            getMapUrl += "&styles=" + styles;
            getMapUrl += "&extent=" + myTerritorialManagement._utility.GetBounds(center, resolution, displayMapWidth, displayMapHeight);
            getMapUrl += "&size=" + displayMapWidth + "," + displayMapHeight;
            getMapUrl += "&geotiff_path=" + path_Geotiff;
        }
        else { // Get Map Request parameters
            getMapUrl += "&layers=" + layers;
            getMapUrl += "&styles=" + styles;
            getMapUrl += "&srs=EPSG:" + sridMap;
            getMapUrl += "&format=image/" + ((formatType !== undefined && formatType != "") ? formatType : "png");
            getMapUrl += "&tiled=true";
            getMapUrl += "&bbox=" + myTerritorialManagement._utility.GetBounds(center, resolution, displayMapWidth, displayMapHeight)
            getMapUrl += "&transparent=true";
            getMapUrl += "&width=" + displayMapWidth;
            getMapUrl += "&height=" + displayMapHeight;
            getMapUrl += "&cql_filter=" + cqlFilter;
        }

        return getMapUrl;
    }

    /**
     * Get capabilities wmts
     * @param {string} geoserver, geoserver url prefixe
     * @param {string} internalGeoserver, internal geoserver url
     */
    this._GetCapabilitiesWmts = function (workspace, geoserver, internalGeoserver) {
        var parser = new WMTSCapabilities();
        var newUrl = window.location.origin + geoserver + "/";
        var xhr = new XMLHttpRequest();
        xhr.open('GET', geoserver + '/' + workspace + '/gwc/service/wmts?REQUEST=GetCapabilities', false);
        xhr.onload = function () {
            myTerritorialManagement._resultWmtsGetCapabilities = parser.read(xhr.responseText.split(internalGeoserver).join(newUrl));
        };
        xhr.send();
    }

    /**
     * Build report page
     * @param {int} idPdmAnalyzeProcess, pdm analyze process id
     */
    this._BuildPdmAnalyzeReport = function (idPdmAnalyzeProcess, tag, locationPlant, scale, idLocationPlantDefinitionInput)
    {
        var idLocationPlantDefinition = -1;
        if(idLocationPlantDefinitionInput)
            idLocationPlantDefinition = idLocationPlantDefinitionInput;

        $.ajax({
            async: false,
            type: 'GET',
            //url: "/rest/app/Request/GetPdmAnalyzeInfo?idPdmAnalyzeProcess=" + idPdmAnalyzeProcess,
            url: "/rest/app/TerritorialManagement/GetPdmAnalyzeInfo?idPdmAnalyzeProcess=" + idPdmAnalyzeProcess + "&idLocationPlantDefinition=" + idLocationPlantDefinition,
            success: function (data) {
                if (!data.error) {
                    switch (data.result.status) {
                        case "SUCCESS":
                            var geom = new WKT().readGeometry(locationPlant.geom_wkt);
                            $('.location-plant-' + tag + '-area-polygon').html(Number(geom.getArea().toFixed(2)).toLocaleString() + " m" + "<sup>2</sup>");

                            // -- Clean --
                            myTerritorialManagement._hashDatatableLayerPdmReport[tag].clear().draw();

                            // Build map
                            myTerritorialManagement.InitMapForReport("id-map-location-plant-" + tag, "location-plant-" + tag + "-report-page", _sridMap, locationPlant, data.result.list_layer_info, scale);

                            // -- Build information layer --
                            var countElement = data.result.list_answer_layer_info.length;
                            var hashForOrder = {};
                            var arrayTableArticle = [];

                            // Group by layer source
                            for (let i = 0; i < countElement; i++) {
                                var objEvent = data.result.list_answer_layer_info[i];
                                var key = objEvent.id_rel_layer_source;
                                if(hashForOrder[key] >= 0) {
                                    var pos = hashForOrder[key];
                                    var objArray = arrayTableArticle[pos];
                                    objArray.article_list += "<p><b>" + objEvent.article_list.split('(')[0].replace("Artigo", "Art.") + "</b>(" + objEvent.article_list.split('(')[1] + "</p>";
                                    arrayTableArticle[pos] = objArray;
                                }
                                else {
                                    arrayTableArticle.push({
                                        id_pdm_layer: objEvent.id_pdm_layer,
                                        layer_name: objEvent.layer_name,
                                        legend_url: objEvent.legend_url,
                                        intersection_area: (Math.round(objEvent.intersection_area*100)/100), //.toString() + " m" + "<sup>2</sup>",
                                        article_list: "<p><b>" + objEvent.article_list.split('(')[0].replace("Artigo", "Art.") + "</b>(" + objEvent.article_list.split('(')[1] + "</p>",
                                        code_ref_pdm_request_type: objEvent.code_ref_pdm_request_type,
                                        geom_type: objEvent.geom_type
                                    });
                                    hashForOrder[key] = arrayTableArticle.length - 1;
                                }
                            }

                            // Group by name
                            var arrayTableByName = [];
                            var hashByName = {};
                            for(var v = 0; v < arrayTableArticle.length; v++) {
                                var objEvent = arrayTableArticle[v];
                                var key = objEvent.layer_name;
                                if(hashByName[key] >= 0) {
                                    var pos = hashByName[key];
                                    var objArray = arrayTableByName[pos];
                                    objArray.intersection_area += objEvent.intersection_area;
                                    objArray.article_list += objEvent.article_list;
                                    arrayTableByName[pos] = objArray;
                                }
                                else {
                                    arrayTableByName.push({
                                        id_pdm_layer: objEvent.id_pdm_layer,
                                        layer_name: objEvent.layer_name,
                                        legend_url: objEvent.legend_url,
                                        intersection_area: objEvent.intersection_area, 
                                        article_list: objEvent.article_list,
                                        code_ref_pdm_request_type: objEvent.code_ref_pdm_request_type,
                                        geom_type: objEvent.geom_type
                                    });
                                    hashByName[key] = arrayTableByName.length - 1;
                                }
                            }

                            // -- Build information layer --
                            for (let i = 0; i < arrayTableByName.length; i++)
                            {
                                var objEvent = arrayTableByName[i];

                                myTerritorialManagement._hashDatatableLayerPdmReport[tag].row.add(
                                {
                                    id_pdm_layer: objEvent.id_pdm_layer,
                                    legend_url: '<img src="' + objEvent.legend_url + '" style="padding-left: 5px;padding-right: 5px;" />',
                                    layer_name: objEvent.layer_name,
                                    intersection_area: (Math.round(objEvent.intersection_area*100)/100).toString() + " m" + ((objEvent.geom_type !== 'polygon')?"":"<sup>2</sup>"),
                                    article_list: objEvent.article_list
                                });
                            }
                            myTerritorialManagement._hashDatatableLayerPdmReport[tag].draw();
                            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                            // Build article information
                            var outputPdmArticleScruture = "";
                            var outputPdmArticleScrutureObj = myTerritorialManagement._utility.GetPropertyInfoInConfigArray(_configurationInfo.propertyInfo, "PLANTA_LOCALIZACAO", "PDM", "OUTPUT_PDM_ARTICLE");
                            if(outputPdmArticleScrutureObj !== undefined)
                                outputPdmArticleScruture = outputPdmArticleScrutureObj.value;

                            var articlesUl = $('<ul class="list pdm-legend-list"></ul>');
                            switch(outputPdmArticleScruture)
                            {
                                case "ARTICLE_ONLY":
                                    var li = $('<li class="article-only"></li>');
                                    // Build article info
                                    myTerritorialManagement._BuildArticleInfo(li, data.result.list_answer_article_info);
                                    articlesUl.append(li);
                                    $('#id-location-plant-' + tag + '-report-page-1' + ' #articles').append(articlesUl);
                                    myTerritorialManagement._GeneratePageReport(tag);
                                    break;
                                default:
                                    var lastIdPdmLayer = "";
                                    for (let r = 0; r < data.result.list_answer_layer_info.length; r++)
                                    {
                                        var objEvent = data.result.list_answer_layer_info[r];

                                        // Check if last id pdm layer is the same then next row
                                        if(lastIdPdmLayer === objEvent.id_pdm_layer)
                                        {
                                            continue;
                                        }
                                        lastIdPdmLayer = objEvent.id_pdm_layer;

                                        // Legend
                                        var intersectionArea = (Math.round(objEvent.intersection_area*100)/100).toString() + " m" + "<sup>2</sup>";
                                        var li = $('<li title="' + objEvent.layer_name + '"></li>');
                                        var div = $('<div class="legend-element-div"></div>');
                                        li.append(div);
                                        div.append('<img src = "' + objEvent.legend_url + '"/>');
                                        var span = $('<span class="legend-title"></span>');
                                        span.html(objEvent.layer_name + ' ' + intersectionArea);
                                        div.append(span);
                                        // Article
                                        var arrayArticle = data.result.list_answer_layer_article_info.filter(c=> c.id_rel_pdm_layer === objEvent.id_pdm_layer);
                                        // Build article info
                                        myTerritorialManagement._BuildArticleInfo(li, arrayArticle, div);
                                        articlesUl.append(li);
                                    }
                                    $('#id-location-plant-' + tag + '-report-page-1' + ' #articles').append(articlesUl);
                                    myTerritorialManagement._GeneratePageReport(tag);
                            }

                            break;
                        default:
                            // do nothing
                    }
                }
            },
            error: function (request, status, error) {
            }
        });
    };

    /**
     * Build article info
     * @param {object} li, li node where goes all the article
     * @param {array} arrayArticle, all the article to show
     * @param {object} div, div node
     */
    this._BuildArticleInfo = function(li, arrayArticle, div)
    {
        for(var p = 0; p < arrayArticle.length; p++)
        {
            var articleObj = arrayArticle[p];
            if(p == 0)
            {
                if(div) div.append($('<hr/>'));
                li.append($('<div class="article-div border">' + (p > 0 ? '<br/>' : '') +
                            ((articleObj.name_title !== null && articleObj.name_title !== "")?'<h3 class="center-element bolder-element">' + articleObj.name_title + '<h3>': '') +
                            ((articleObj.description_title !== null && articleObj.description_title !== "")?'<h3 class="center-element bolder-element">' + articleObj.description_title + '<h3>': '') +
                            ((articleObj.name_chapter !== null && articleObj.name_chapter !== "")?'<h4 class="center-element bolder-element">' + articleObj.name_chapter + '<h4>': '') +
                            ((articleObj.description_chapter !== null && articleObj.description_chapter !== "")?'<h5 class="center-element bolder-element">' + articleObj.description_chapter + '<h5>': '') +
                            ((articleObj.name_section !== null && articleObj.name_section !== "")?'<h4 class="center-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                            ((articleObj.description_section !== null && articleObj.description_section !== "")?'<h5 class="center-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                            ((articleObj.name_subsection !== null && articleObj.name_subsection !== "")?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                            ((articleObj.description_subsection !== null && articleObj.description_subsection !== "")?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                            ((articleObj.name_article !== null && articleObj.name_article !== "")?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                            ((articleObj.description_article !== null && articleObj.description_article !== "")?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                            articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
            }
            else
            {
                if(articleObj.name_title !== "" && articleObj.name_title !== arrayArticle[p-1].name_title) {
                    li.append($('<div class="article-div border"><br/>' +
                                ((articleObj.name_title)?'<h3 class="center-element bolder-element">' + articleObj.name_title + '<h3>': '') +
                                ((articleObj.description_title)?'<h3 class="center-element bolder-element">' + articleObj.description_title + '<h3>': '') +
                                ((articleObj.name_chapter)?'<h4 class="center-element bolder-element">' + articleObj.name_chapter + '<h4>': '') +
                                ((articleObj.description_chapter)?'<h5 class="center-element bolder-element">' + articleObj.description_chapter + '<h5>': '') +
                                ((articleObj.name_section)?'<h4 class="center-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                                ((articleObj.description_section)?'<h5 class="center-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                }
                else if(articleObj.name_chapter !== "" && articleObj.name_chapter !== arrayArticle[p-1].name_chapter) {
                    li.append($('<div class="article-div border"><br/>' +
                                ((articleObj.name_chapter)?'<h4 class="center-element bolder-element">' + articleObj.name_chapter + '<h4>': '') +
                                ((articleObj.description_chapter)?'<h5 class="center-element bolder-element">' + articleObj.description_chapter + '<h5>': '') +
                                ((articleObj.name_section)?'<h4 class="center-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                                ((articleObj.description_section)?'<h5 class="center-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                        
                }
                else if(articleObj.name_section != "" && articleObj.name_section !== arrayArticle[p-1].name_section) {
                    li.append($('<div class="article-div"><br/>' +
                                ((articleObj.name_section)?'<h4 class="center-element bold-element bolder-element">' + articleObj.name_section + '<h4>': '') +
                                ((articleObj.description_section)?'<h5 class="center-element bold-element bolder-element">' + articleObj.description_section + '<h5>': '') +
                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                        
                }
                else if(articleObj.name_subsection !== "" && articleObj.name_subsection !== arrayArticle[p-1].name_subsection) {
                    li.append($('<div class="article-div"><br/>' +
                                ((articleObj.name_subsection)?'<h4 class="center-element bolder-element">' + articleObj.name_subsection + '<h4>': '') +
                                ((articleObj.description_subsection)?'<h5 class="center-element bolder-element">' + articleObj.description_subsection + '<h5>': '') +
                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));
                                        
                }
                else {
                    li.append($('<div class="article-div"><br/>' +
                                ((articleObj.name_article)?'<h6 class="center-element bolder-element">' + articleObj.name_article + '<h6>': '') +
                                ((articleObj.description_article)?'<h6 class="center-element bolder-element">' + articleObj.description_article + '<h6>': '') +
                                articleObj.article_text + (p === arrayArticle.length - 1 ? '<br/>' : '') + '</div>'));                                        
                }
            }
        }
    }

    /**
     * Generate page for pdm report
     */
    this._GeneratePageReport = function(tag) {
        var idPageOrigin = 'id-location-plant-pdmo-report-page-1';
        var idNodePage = "";
        switch(tag) {
            case "pdmo":
                idPageOrigin = 'id-location-plant-pdmo-report-page-1';
                idNodePage = "id-location-plant-pdmo-report-page-";
                break;
            case "pdmc":
                idPageOrigin = 'id-location-plant-pdmc-report-page-1';
                idNodePage = "id-location-plant-pdmc-report-page-";
                break;
            case "pdmpp":
                idPageOrigin = 'id-location-plant-pdmpp-report-page-1';
                idNodePage = "id-location-plant-pdmpp-report-page-";
                break;
            default:
                // do nothing
        }
        
        var fullHeightReport = $('#' + idPageOrigin)[0].scrollHeight;
        var pageHeight = $('.plant-report.' + tag + ' .wrapper')[0].scrollHeight;
        var nrPage = (Math.floor(fullHeightReport/pageHeight) + ((fullHeightReport%pageHeight > 0)? 1:0)); // - 1;
        var templatePage = '<page class="plant-report ' + tag + '" size="A4" layout="portrait">'+
                             '<div class="wrapper">' +
                               '<div id="ID_GENERATE" class="div-plant"></div>' +
                             '</div>' +
                           '</page>';

        var constStyleValue = 27.9;
        var marginTopValue = 0;
        var heightValue = 55.8;
        for(var i = 2; i <= nrPage; i++) {
            var idPage = idNodePage + i;
            marginTopValue += constStyleValue;
            if( i > 2)
                heightValue += constStyleValue;
            $(templatePage.replace("ID_GENERATE", idPage)).insertAfter($('.' + tag).last());

            var copy = $("#" + idPageOrigin).clone().attr("id", idPageOrigin + "-copy-" + i).css({
                "margin-top": "-" + marginTopValue + "cm",
                "height": heightValue + "cm"});
            $("#" + idPage).append(copy);
        }
    };

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Event close location plant modal
     */
    $('#id-modal-location-plant-cancel').on('click', function () {
        $('#id-modal-location-plant').toggle('ol-hidden');
    });

    /**
     * Event close pdm analyze modal
     */
    $('#id-modal-pdm-analyze-result-close').on('click', function () {
        $('#id-modal-pdm-analyze-result').toggle('ol-hidden');
    });

    /**
     * Event close pdm analyze entity modal
     */
    $('#id-modal-pdm-analyze-entity-result-close').on('click', function () {
        $('#id-modal-pdm-analyze-entity-result').toggle('ol-hidden');
    });

    /**
     * Event generate pdm analyze pdf
     */
    $('#id-modal-pdm-analyze-entity-result-print').on('click', function () {
        var processNumber = $('#id-modal-pdm-analyze-entity-result-process')[0].innerHTML;

        var arrayLayer = [{
            internalGeoserver: "http://192.168.0.25:8080/geoserver/",
            geoserver: "/geoserver/9",
            workspace: "GP_PONTA_DELGADA",
            layerName: "Ortos2019"
        }];

        myTerritorialManagement.GeneratePdmAnalyzePdf(processNumber, arrayLayer);
    });

    /**
     * Event print pdm analyze modal
     */
    $('#id-modal-pdm-analyze-result-print').click(function () {
        window.print();
    });

    /**
     * Event close location plant modal
     */
    $('#id-modal-location-plant-email-cancel').on('click', function () {
        $('#id-modal-location-plant-email').hide();
    });

    /**
     * Event continue location plant modal
     */
    $('#id-modal-location-plant-continue').on('click', function () {

        if($('#id-modal-location-plant-content ul > li.active').next().length > 0 ) {
            $('#id-modal-location-plant-content ul > li.active').next().find('a').trigger('click');
        }
        else {
            // Close modal
            $('#id-modal-location-plant').toggle('ol-hidden');

            // Msg for draw
            toastr.options.positionClass = 'toast-top-center';
            toastr["info"]("Desenhe agora o seu polígono");
            toastr.options.positionClass = 'toast-bottom-center';

            // Show menu botton bar
            if (!$('#menubar-bottom-pl').is(':visible'))
                $('#menubar-bottom-pl').toggle('ol-hidden');
        }
    });

    /**
     * Event clean location plant modal
     */
    $('#id-modal-location-plant-clean').on('click', function () {
        $('#id-modal-location-plant-form input').val("");
    });

    /**
     * Generate localtion plant background
     */
    $('#id-modal-location-plant-email-generate').on('click', function () {

        // Fill url
        myTerritorialManagement._locationPlantInfo.url = window.origin;

        // Fill email
        myTerritorialManagement._locationPlantInfo.emailAddress = $('#id-modal-location-plant-email-address').val();

        // Close modal
        $('#id-modal-location-plant-email').hide();

        // Start wait
        myTerritorialManagement._utility.ShowWait('offcanvas-map-spinner', true);

        // Execute location plan
        myTerritorialManagement.ExecuteLocationPlantReport();
    });

    /**
     * Event check location plan
     */
    $('#id-modal-location-plant-location-active').on('change', function () {
        $('#layer-location-plant-active-tree-base-row').toggle('ol-hidden');
        $('#layer-location-plant-active-tree-row').toggle('ol-hidden');
        $('#id-modal-location-plant-pl-scale-div').toggle('ol-hidden');
        if (this.checked) {

            //myTerritorialManagement._hashOption.location_plant = {

            //}
        }
    });

    /**
     * Event check location plan pdmo
     */
    $('#id-modal-location-plant-location-pdmo-active').on('change', function () {
        $('#id-modal-location-plant-pdmo-pl-scale-div').toggle('ol-hidden');
        //if (this.checked) {
        //    myTerritorialManagement._hashOption.location_plant_pdmo = {}
        //}
    });

    /**
     * Event check location plan pdmr
     */
    $('#id-modal-location-plant-location-pdmr-active').on('change', function () {
        $('#id-modal-location-plant-pdmr-pl-scale-div').toggle('ol-hidden');
        //if (this.checked) {
        //    myTerritorialManagement._hashOption.location_plant_pdmr = {}
        //}
    });

    /**
     * Event check location plan pdmpp
     */
    $('#id-modal-location-plant-location-pdmpp-active').on('change', function () {
        $('#id-modal-location-plant-pdmpp-pl-scale-div').toggle('ol-hidden');
        //if (this.checked) {
        //    myTerritorialManagement._hashOption.location_plant_pdmpp = {}
        //}
    });

    /**
     * Event check location plan pdmc
     */
    $('#id-modal-location-plant-location-pdmc-active').on('change', function () {
        $('#id-modal-location-plant-pdmc-pl-scale-div').toggle('ol-hidden');
        //if (this.checked) {
        //    myTerritorialManagement._hashOption.location_plant_pdmc = {}
        //}
    });

    /**
     * Event on change tab modal form
     */
    $('#id-modal-location-plant-tab-option li').on('click', function() {
        if($(this).find('a').attr('href') === '#id-modal-location-plant-info')
            $('#id-modal-location-plant-clean').show();
        else
            $('#id-modal-location-plant-clean').hide();
    });

    /**
     * Ajust table on show modal pdm analyze
     */
    //$('#id-modal-pdm-analyze-result').on('shown.bs.modal', function () {
    //    $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
    //    alert("1212");
    //});

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init territorial management information
 * @param {object} mapSgs, map object
 */
TerritorialManagement.prototype.InitTerritorialManagement = function (mapSgs)
{
    var myTerritorialManagement = this;

    // Map
    this._mapSgs = mapSgs;

    // Settings location plant
    var settingLocationPlant = this._mapSgs.getSettings().configurationInfo.locationPlantInfo;

    // Analize pdm - view 
    var regulationPdm = this._utility.GetPropertyInfoInConfigArray(this._mapSgs.getSettings().configurationInfo.propertyInfo, "ANALISE_PDM", "RESULT", "REGULAMENTO_PDM");
    if(regulationPdm !== undefined && regulationPdm.value === "true")
    {
        $('.modal-button-pdm-doc-download').show();
    }

    // Pdm
    if (this._mapSgs.getSettings().getVisibleOperations().LocationPlantPdm) {
        this._pdm = new Pdm();

        this._pdm._SetRequestTypes();
        this._pdm._SetLegalDocuments(this._mapSgs.getSettings()._mapSettings.map_info.cod_owner);
    }

    // -- Init state occurence evet data begin ----------------------------------------------------
    if ($("#id-modal-location-plant-body-date-issue").attr("block-date") == "true") {
        $('#id-modal-location-plant-body-date-issue').prop('readonly', true);
        if ($("#id-modal-location-plant-body-date-issue").attr("fill-auto") == "true") {
            var month = ((new Date()).getMonth() + 1).toString().padStart(2, '0');
            var day = ((new Date()).getDate()).toString().padStart(2, '0');
            var year = ((new Date()).getFullYear()).toString();
            $("#id-modal-location-plant-body-date-issue").val(year + "-" + month + "-" + day);
        }
    }
    else {
        $('#id-modal-location-plant-body-date-issue').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });
        if ($("#id-modal-location-plant-body-date-issue").attr("fill-auto") == "true") {
            var month = ((new Date()).getMonth() + 1).toString().padStart(2, '0');
            var day = ((new Date()).getDate()).toString().padStart(2, '0');
            var year = ((new Date()).getFullYear()).toString();
            var dateNow = year + "-" + month + "-" + day;
            $("#id-modal-location-plant-body-date-issue").val(dateNow);
        }
    }

    // -- Create group plant ----------------------------------------------------------------------
    if (settingLocationPlant.definition.list_location_plant_group && settingLocationPlant.definition.list_location_plant_group.length > 0) {
        myTerritorialManagement._hashOptionGroup = {};
        for (var i = 0; i < settingLocationPlant.definition.list_location_plant_group.length; i++) {
            var locationPlantGroup = settingLocationPlant.definition.list_location_plant_group[i];

            var cloneLocationPlantGroup = $('<div id="id-modal-location-plant-group-' + locationPlantGroup.name + '" class="row option-title-row group-location-plant" style="border: none;display:none;">' +
                                                '<div class= "col-md-12" style = "padding-left: 0px;">' + 
                                                    '<label for="id-modal-location-plant-group-active-' + locationPlantGroup.name + '" class="label-switch pull-left" id="id-modal-location-plant-group-active-label-' + locationPlantGroup.name + '">' +
                                                        '<input type="checkbox" class="switch group-location-plant-main-swicht" active-selection-group="' + locationPlantGroup.active_selection_group + '" name="toggle-history" id="id-modal-location-plant-group-active-' + locationPlantGroup.name + '" group-name="' + locationPlantGroup.name + '">' +
                                                        '<span class="status" style="margin-left: 0px;"></span>' +
                                                        '<span class="modal-location-plant-active-title group-location-plant">' + locationPlantGroup.pretty_name + '</span>' +
                                                    '</label>' +
                                                '</div>' +
                                                '<div id="id-modal-location-plant-group-list-' + locationPlantGroup.name + '" style="display:none;"></div>' +
                                            '</div>');
            $('#id-modal-location-plant-pdm').append(cloneLocationPlantGroup);
            cloneLocationPlantGroup.show();

            // Build location plant definition
            myTerritorialManagement._hashOptionGroup[locationPlantGroup.name] = {};

            $('#id-modal-location-plant-group-active-' + locationPlantGroup.name).on('change', function ()
            {
                var groupName = $(this).attr('group-name');
                var idSwitch = 'id-modal-location-plant-group-active-' + groupName;

                // Show/hide group with location plant option
                if ($(this).attr('active-selection-group') == 'true') {
                    if (this.checked)
                        $('#id-modal-location-plant-group-list-' + groupName).show();
                    else
                        $('#id-modal-location-plant-group-list-' + groupName).hide();
                }

                // Clear all the location plant selected
                myTerritorialManagement._hashOption.cartography_extract = {};

                // If the group of location plant has switch active and has no selection active then add all the location plant of the group
                if (this.checked && $(this).attr('active-selection-group') == 'false')
                {
                    myTerritorialManagement._hashOption.cartography_extract = myTerritorialManagement._hashOptionGroup[groupName];
                }

                // For all other location plant group switch
                $('#id-modal-location-plant-pdm .group-location-plant input.group-location-plant-main-swicht').not('#' + idSwitch).each(function (i, obj) {
                    obj.checked = false;
                    if (obj.getAttribute("active-selection-group") === 'true')
                    {
                        var groupNameSelect = obj.getAttribute("group-name");
                        $('#id-modal-location-plant-group-list-' + groupNameSelect).hide();

                        $('#id-modal-location-plant-group-list-' + $('#' + obj.id).attr("group-name")).find('input.switch').each(function (i, obj)
                        {
                            if (obj.checked)
                            {
                                $(obj).trigger('click');
                            }
                        });
                    }
                });

                // If the location plant group switch has being closed and active selection is true then close all option of this switch
                if (!this.checked && $(this).attr('active-selection-group') == 'true')
                {
                    $('#id-modal-location-plant-group-list-' + groupName).find('input.switch').each(function (i, obj) {
                        if (obj.checked) {
                            $(obj).trigger('click');
                        }
                    });
                }
            });
        }

        // -- Fill location plant in group --------------------------------------------------------
        // Get 
        var arrayLocationPlantGroup = settingLocationPlant.definition.list_location_plant.filter(c => c.location_plant_type === "LOCATION_PLANT_GROUP");

        if (arrayLocationPlantGroup.length > 0) {
            for (var i = 0; i < arrayLocationPlantGroup.length; i++) {
                var locationPlantGroupObj = arrayLocationPlantGroup[i];
                var arrayScale = JSON.parse(locationPlantGroupObj.scale_array);

                // Get id layer source
                var idLayerSource = settingLocationPlant.definition.list_base_layer.find(c => c.id_location_plant_definition === locationPlantGroupObj.id).id_layer_source;

                // Build location plant group
                let infoJson = '{ "price_value_info": "' + locationPlantGroupObj.price_value_info + '"}';
                myTerritorialManagement._hashLocationPlantGroup[locationPlantGroupObj.id] = { "info_json": infoJson };
                
                // active selection group
                if (locationPlantGroupObj.active_selection_group) {
                    var idParentNode = 'id-modal-location-plant-group-list-' + locationPlantGroupObj.name_group;

                    // Build option
                    myTerritorialManagement.BuildLocationPlantGroupOptionFromLayerBase(locationPlantGroupObj.name_group, idParentNode, idLayerSource, locationPlantGroupObj.label, arrayScale, locationPlantGroupObj.scale_default, locationPlantGroupObj.id, false, "", false, locationPlantGroupObj.active_selection_group, locationPlantGroupObj.active_selection);
                }
                else {
                    var idLocationPlantDefinition = idLayerSource + "_" + locationPlantGroupObj.scale_default;
                    var infoJsonPl = myTerritorialManagement._hashLocationPlantGroup[locationPlantGroupObj.id].info_json;
                    myTerritorialManagement._hashOptionGroup[locationPlantGroupObj.name_group][idLocationPlantDefinition] = { "idSelectScale": -1, "scale": locationPlantGroupObj.scale_default, "idLocationPlantDefinition": locationPlantGroupObj.id, "info_json": infoJsonPl };
                }
            }
        }
    }

    // -- Fill Location plant ---------------------------------------------------------------------
    if(settingLocationPlant.has_location_plant) {
        // Get location plant default information
        var locationPlantInfo = settingLocationPlant.definition.list_location_plant.find(c=> c.location_plant_type === "LOCATION_PLANT");

        if(locationPlantInfo) {
            // Define label
            $('#id-modal-location-plant-location-active-label .modal-location-plant-active-title')[0].innerHTML = locationPlantInfo.label;

            // Remove layer tree if not use
            if(!locationPlantInfo.has_layer_tree) {
                $('#layer-location-plant-active-tree-row').remove();
            }
            // Fill scale
            var arrayScale = JSON.parse(locationPlantInfo.scale_array);
            this._utility.SetScaleInSelect('id-modal-location-plant-pl-scale', arrayScale, locationPlantInfo.scale_default);

            // Get location plant definition id
            let infoJson = '{ "price_value_info": "' + locationPlantInfo.price_value_info + '"}';
            this._hashOption.location_plant = {id_location_plant_definition: locationPlantInfo.id, info_json: infoJson};
        }
    }

    // -- Fill cartography extract ----------------------------------------------------------------
    if(settingLocationPlant.has_cartography_extract) {
        // Get all 
        var arrayCartographyExtract = settingLocationPlant.definition.list_location_plant.filter(c=> c.location_plant_type === "LOCATION_PLANT_CARTOGRAPHY_EXTRACT");

        if(arrayCartographyExtract.length > 0) {
            for(var i = 0; i < arrayCartographyExtract.length; i++) {
                var cartoExtractObj = arrayCartographyExtract[i];
                var arrayScale = JSON.parse(cartoExtractObj.scale_array);

                // Get id layer source
                var idLayerSource = settingLocationPlant.definition.list_base_layer.find(c=> c.id_location_plant_definition === cartoExtractObj.id).id_layer_source;

                // Build cartography extract
                let infoJson = '{ "price_value_info": "' + cartoExtractObj.price_value_info + '"}';
                this._hashCartographyExtrac[cartoExtractObj.id] = {"info_json": infoJson};
                this.BuildCartographyExtractOptionFromLayerBase(idLayerSource, cartoExtractObj.label, arrayScale, cartoExtractObj.scale_default, cartoExtractObj.id, false, "", false);
            }
        }
    }

    // -- Fill Location plant PDM -----------------------------------------------------------------
    if(settingLocationPlant.has_location_plant_pdm) {

        // -- PDM ORDENAMENTO --
        // Get location plant pdmo information
        var locationPlantInfoPdmo = settingLocationPlant.definition.list_location_plant.find(c=> c.name === "CARTOGRAPHY_EXTRACT_PDM_ORDENAMENTO");

        if(locationPlantInfoPdmo) {
            // Show
            $('#id-modal-location-plant-location-pdmo').show();

            // Define label
            $('#id-modal-location-plant-location-pdmo .modal-location-plant-active-title')[0].innerHTML = locationPlantInfoPdmo.label;

            // Fill scale
            var arrayScalePdmo = JSON.parse(locationPlantInfoPdmo.scale_array);
            this._utility.SetScaleInSelect('id-modal-location-plant-pdmo-pl-scale', arrayScalePdmo, locationPlantInfoPdmo.scale_default);

            // Plant information in json format
            let infoJson = '{ "price_value_info": "' + locationPlantInfoPdmo.price_value_info + '"}';

            // -- Pdmo cartography extract --
            if(locationPlantInfoPdmo.is_cartography) {
                // Get id layer source
                var findLayerSourceInfo = settingLocationPlant.definition.list_base_layer.find(c=> c.id_location_plant_definition === locationPlantInfoPdmo.id);
                if(findLayerSourceInfo) {
                    var idLayerSource = findLayerSourceInfo.id_layer_source;
                    this._hashOption.cartography_extract_pdmo[idLayerSource]= {id_location_plant_definition: locationPlantInfoPdmo.id, info_json: infoJson};
                    $('#id-modal-location-plant-pdm').attr('pdmo', 'cartography_extract_pdmo');
                }
            }
            else { 
                // -- Pdmo with layer and article info --
                this._hashOption.location_plant_pdmo = {id_location_plant_definition: locationPlantInfoPdmo.id, info_json: infoJson};
            }

            // Move to group if exists
            //if (locationPlantInfoPdmo.name_group && locationPlantInfoPdmo.name_group !== '') {
            //    $('#id-modal-location-plant-location-pdmo').appendTo("#id-modal-location-plant-group-list-" + locationPlantInfoPdmo.name_group);
            //    $('#id-modal-location-plant-location-pdmo-active')[0].checked = true;
            //    $('#id-modal-location-plant-location-pdmo-active').hide();
            //    $('#id-modal-location-plant-location-pdmo span.status').hide();
            //    $('#id-modal-location-plant-pdmo-pl-scale-div').show();
            //}
        }

        // -- PDM CONDICIONANTE ---
        // Get location plant pdmc information
        var locationPlantInfoPdmc = settingLocationPlant.definition.list_location_plant.find(c=> c.name === "CARTOGRAPHY_EXTRACT_PDM_CONDICIONANTES");

        if(locationPlantInfoPdmc) {
            // Show
            $('#id-modal-location-plant-location-pdmc').show();

            // Define label
            $('#id-modal-location-plant-location-pdmc .modal-location-plant-active-title')[0].innerHTML = locationPlantInfoPdmc.label;

            // Fill scale
            var arrayScalePdmc = JSON.parse(locationPlantInfoPdmc.scale_array);
            this._utility.SetScaleInSelect('id-modal-location-plant-pdmc-pl-scale', arrayScalePdmc, locationPlantInfoPdmc.scale_default);

            // Plant information in json format
            let infoJson = '{ "price_value_info": "' + locationPlantInfoPdmc.price_value_info + '"}';

            // -- Pdmc cartography extract --
            if(locationPlantInfoPdmc.is_cartography) {
                // Get id layer source
                var findLayerSourceInfo = settingLocationPlant.definition.list_base_layer.find(c=> c.id_location_plant_definition === locationPlantInfoPdmc.id);
                if(findLayerSourceInfo) {
                    var idLayerSource = findLayerSourceInfo.id_layer_source;
                    this._hashOption.cartography_extract_pdmc[idLayerSource] = {idLocationPlantDefinition: locationPlantInfoPdmc.id, info_json: infoJson};
                    $('#id-modal-location-plant-pdm').attr('pdmc', 'cartography_extract_pdmc');
                }
            }
            else { 
                // -- Pdmc with layer and article info --
                this._hashOption.location_plant_pdmc = {id_location_plant_definition: locationPlantInfoPdmc.id, info_json: infoJson};
            }

            // Move to group if exists
            //if (locationPlantInfoPdmc.name_group && locationPlantInfoPdmc.name_group !== '') {
            //    $('#id-modal-location-plant-location-pdmc').appendTo("#id-modal-location-plant-group-list-" + locationPlantInfoPdmc.name_group);
            //    $('#id-modal-location-plant-location-pdmc-active')[0].checked = true;
            //    $('#id-modal-location-plant-location-pdmc-active').hide();
            //    $('#id-modal-location-plant-location-pdmc span.status').hide();
            //    $('#id-modal-location-plant-pdmc-pl-scale-div').show();
            //}
        }
    }

    // -- Fill Location plant MAPA RUIDO ----------------------------------------------------------
    if(settingLocationPlant.has_location_plant_pdm_ruido) {
        // Get location plant pdmr information
        var locationPlantInfoPdmr = settingLocationPlant.definition.list_location_plant.find(c=> c.name === "MAPA_RUIDO");

        if(locationPlantInfoPdmr) {
            // Show
            $('#id-modal-location-plant-location-pdmr').show();

            // Define label
            $('#id-modal-location-plant-location-pdmr .modal-location-plant-active-title')[0].innerHTML = locationPlantInfoPdmr.label;

            // Fill scale
            var arrayScalePdmr = JSON.parse(locationPlantInfoPdmr.scale_array);
            this._utility.SetScaleInSelect('id-modal-location-plant-pdmr-pl-scale', arrayScalePdmr, locationPlantInfoPdmr.scale_default);

            // Plant information in json format
            let infoJson = '{ "price_value_info": "' + locationPlantInfoPdmr.price_value_info + '"}';

            // -- Pdmr cartography extract --

            // Get id layer source
            var findLayerSourceInfo = settingLocationPlant.definition.list_base_layer.find(c=> c.id_location_plant_definition === locationPlantInfoPdmr.id);
            if(findLayerSourceInfo) {
                var idLayerSource = findLayerSourceInfo.id_layer_source;
                this._hashOption.cartography_extract_pdmr[idLayerSource] = { id_location_plant_definition: locationPlantInfoPdmr.id, info_json: infoJson};
                $('#id-modal-location-plant-pdm').attr('pdmr', 'cartography_extract_pdmr');
            }
        }
    }

    // -- Fill Location plant MAPA PDM Plano de Pormenor -----------------------------------------------------
    if(settingLocationPlant.has_location_plant_pdmpp) {
        // Get location plant pdm pp information
        var locationPlantInfoPdmPp = settingLocationPlant.definition.list_location_plant.find(c=> c.name === "CARTOGRAPHY_EXTRACT_PDM_PLANO_PORMENOR");

        if(locationPlantInfoPdmPp) {
            // Show
            $('#id-modal-location-plant-location-pdmpp').show();

            // Define label
            $('#id-modal-location-plant-location-pdmpp .modal-location-plant-active-title')[0].innerHTML = locationPlantInfoPdmPp.label;

            // Fill scale
            var arrayScalePdmPp = JSON.parse(locationPlantInfoPdmPp.scale_array);
            this._utility.SetScaleInSelect('id-modal-location-plant-pdmpp-pl-scale', arrayScalePdmPp, locationPlantInfoPdmPp.scale_default);

            // Plant information in json format
            let infoJson = '{ "price_value_info": "' + locationPlantInfoPdmPp.price_value_info + '"}';

            // -- Pdmpp cartography extract --
            if(locationPlantInfoPdmPp.is_cartography) {
                // Get id layer source
                var findLayerSourceInfo = settingLocationPlant.definition.list_base_layer.find(c=> c.id_location_plant_definition === locationPlantInfoPdmPp.id);
                if(findLayerSourceInfo) {
                    var idLayerSource = findLayerSourceInfo.id_layer_source;
                    this._hashOption.cartography_extract_pdmpp[idLayerSource] = {idLocationPlantDefinition: locationPlantInfoPdmPp.id, info_json: infoJson};
                    $('#id-modal-location-plant-pdm').attr('pdmpp', 'cartography_extract_pdmc');
                }
            }
            else { 
                // -- Pdmc with layer and article info --
                this._hashOption.location_plant_pdmpp = {id_location_plant_definition: locationPlantInfoPdmPp.id, info_json: infoJson};
            }
        }
    }

    // -- Init PDM analyze object -----------------------------------------------------------------
    if (this._mapSgs.getSettings().getVisibleOperations().PDMAnalyze) {

        // -- Table layer result --
        var columnDefArrayLayerResult = [];

        // id_map_layer
        columnDefArrayLayerResult.push({
            'data': 'id_pdm_layer',
            'type': 'readonly',
            'visible': false
        });
        // layer_name
        columnDefArrayLayerResult.push({
            'data': 'layer_name',
            'title': 'Tema',
            'name': 'Tema',
            'label': 'Tema',
            'type': 'readonly',
            'className': 'dt-body-center dt-body-border dt-body-left-with dt-font',
            'orderable': false,
            'width': '20%'
        });
        // intersection_area
        columnDefArrayLayerResult.push({
            'data': 'intersection_area',
            'title': 'Área Intersectada',
            'name': 'Área Intersectada',
            'label': 'Área Intersectada',
            'type': 'readonly',
            'className': 'dt-body-center dt-body-border dt-body-left-with dt-font',
            'orderable': false,
            'width': '10%'
        });
        // Artigos Aplicáveis
        columnDefArrayLayerResult.push({
            'data': 'article_list',
            'title': 'Artigos Aplicáveis',
            'name': 'Artigos Aplicáveis',
            'label': 'Artigos Aplicáveis',
            'type': 'readonly',
            'className': 'dt-body-left dt-body-border dt-body-padding-left dt-font2',
            'orderable': false,
            'width': '70%'
        });

        this._datatableLayerPdm = $('#id-modal-pdm-analyze-layer-result-table').DataTable({
            "dom": '<rtip',
            "autoWidth": false,
            "destroy": true,
            "language": {
                "emptyTable": 'Sem informação',
            },
            "fixedHeader": false,
            "info": false,
            "scrollY": $('#id-modal-pdm-analyze-layer-result-table-zone').height() - 27,
            "scrollCollapse": false,
            "deferRender": false,
            "scroller": false,
            "paging": false,
            "ordering": false,
            "columns": columnDefArrayLayerResult,
            "select": false,
            "name": "modal-pdm-analyze-layer-result",
            "rowId": 'id_pdm_layer',
            "iDisplayLength": 4
        });

        $('#id-modal-pdm-analyze-layer-result-table').on('draw.dt', function(){
            $($.fn.dataTable.tables(true)).DataTable().columns.adjust();
        })
    }
};

/**
 * Init report information
 * @param {object} mapSgs, map object
 */
TerritorialManagement.prototype.InitReportTerritorialManagement = function () {

    // -- Table layer result --
    var columnDefArrayLayerResult = [];

    // id_map_layer
    columnDefArrayLayerResult.push({
        'data': 'id_pdm_layer',
        'type': 'readonly',
        'visible': false
    });
    // layer_name
    columnDefArrayLayerResult.push({
        'data': 'legend_url',
        'title': '',
        'name': '',
        'label': '',
        'type': 'readonly',
        'className': 'dt-body-center dt-body-left-with dt-body-border-bottom dt-font2',
        'width': '150px;'
    });
    // layer_name
    columnDefArrayLayerResult.push({
        'data': 'layer_name',
        'title': 'Tema',
        'name': 'Tema',
        'label': 'Tema',
        'type': 'readonly',
        'className': 'dt-body-center dt-body-left-with dt-body-border-bottom dt-font2',
        'orderable': false,
        'width': '150px;'
    });
    // intersection_area
    columnDefArrayLayerResult.push({
        'data': 'intersection_area',
        'title': 'Interseção',
        'name': 'Interseção',
        'label': 'Interseção',
        'type': 'readonly',
        'className': 'dt-body-center dt-body-left-with dt-body-border-bottom dt-font2',
        'orderable': false,
        'width': '150px'
    });
    // Artigos Aplicáveis
    columnDefArrayLayerResult.push({
        'data': 'article_list',
        'title': 'Artigos Aplicáveis',
        'name': 'Artigos Aplicáveis',
        'label': 'Artigos Aplicáveis',
        'type': 'readonly',
        'className': 'dt-body-left dt-body-padding-left dt-body-border-bottom dt-font2',
        'orderable': false,
        'width': '400px'
    });

    // Table pdmo
    this._hashDatatableLayerPdmReport['pdmo'] = $('#id-location-plant-pdmo-result-detail-table').DataTable({
        "dom": '<rtip',
        "autoWidth": false,
        "destroy": true,
        "language": {
            "emptyTable": 'Sem informação',
        },
        "fixedHeader": false,
        "info": false,
        //"scrollY": $('#id-location-plant-pdmo-result-detail-table-zone').height() - 27,
        "scrollCollapse": false,
        "deferRender": false,
        "scroller": false,
        "paging": false,
        "ordering": false,
        "columns": columnDefArrayLayerResult,
        "select": false,
        "name": "modal-pdm-analyze-layer-result-pdmo",
        "rowId": 'id_pdm_layer',
        "iDisplayLength": 4
    });

    // Table pdmc
    this._hashDatatableLayerPdmReport['pdmc'] = $('#id-location-plant-pdmc-result-detail-table').DataTable({
        "dom": '<rtip',
        "autoWidth": false,
        "destroy": true,
        "language": {
            "emptyTable": 'Sem informação',
        },
        "fixedHeader": false,
        "info": false,
        //"scrollY": $('#id-location-plant-pdmc-result-detail-table-zone').height() - 27,
        "scrollCollapse": false,
        "deferRender": false,
        "scroller": false,
        "paging": false,
        "ordering": false,
        "columns": columnDefArrayLayerResult,
        "select": false,
        "name": "modal-pdm-analyze-layer-result-pdmc",
        "rowId": 'id_pdm_layer',
        "iDisplayLength": 4
    });

    // Table pdmpp
    this._hashDatatableLayerPdmReport['pdmpp'] = $('#id-location-plant-pdmpp-result-detail-table').DataTable({
        "dom": '<rtip',
        "autoWidth": false,
        "destroy": true,
        "language": {
            "emptyTable": 'Sem informação',
        },
        "fixedHeader": false,
        "info": false,
        //"scrollY": $('#id-location-plant-pdmc-result-detail-table-zone').height() - 27,
        "scrollCollapse": false,
        "deferRender": false,
        "scroller": false,
        "paging": false,
        "ordering": false,
        "columns": columnDefArrayLayerResult,
        "select": false,
        "name": "modal-pdm-analyze-layer-result-pdmpp",
        "rowId": 'id_pdm_layer',
        "iDisplayLength": 4
    });
};